import './index.css';var $t = Object.defineProperty;
var zt = (i, e, t) => e in i ? $t(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var I = (i, e, t) => zt(i, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as F, jsx as p, Fragment as q } from "react/jsx-runtime";
import { Button as R, Tooltip as Ht, Modal as wt, Field as ge, Input as Ne, Textarea as _t, Collapse as Ee, Radio as Ce, Select as Ut, RadioButtonGroup as Wt, Checkbox as Kt, Scrollbar as Yt } from "@repo/go-ui";
import { hasValue as T, getWellStatusColor as Xt, equalsDeep as Zt } from "@repo/utils";
import { observer as L } from "mobx-react-lite";
import { useState as re, useMemo as ke, useEffect as Me } from "react";
import { useTranslation as j, initReactI18next as qt, I18nextProvider as Jt } from "react-i18next";
import { ExpandUpLight as Tt, ExpandDownLight as Ct, BookmarkFill as Qt, BookmarkLight as en, DotsEditCustom as tn, CloseMiniLine as Ft, DoneLight as xt, FilterAltLight as nn, ExportLight as rn, ArhiveAltExportLight as ln, CloseRoundLight as sn, SearchLight as on, VerticalCustom as an, CheckRingLight as cn } from "@repo/go-icons";
import { action as y, makeObservable as Se, reaction as Ge, observable as W, computed as _, flow as U, runInAction as K } from "mobx";
import dn from "i18next";
function kt(i) {
  var e, t, n = "";
  if (typeof i == "string" || typeof i == "number") n += i;
  else if (typeof i == "object") if (Array.isArray(i)) {
    var r = i.length;
    for (e = 0; e < r; e++) i[e] && (t = kt(i[e])) && (n && (n += " "), n += t);
  } else for (t in i) i[t] && (n && (n += " "), n += t);
  return n;
}
function D() {
  for (var i, e, t = 0, n = "", r = arguments.length; t < r; t++) (i = arguments[t]) && (e = kt(i)) && (n && (n += " "), n += e);
  return n;
}
const pn = {
  status: [],
  workStartDateFrom: null,
  workStartDateTo: null,
  organizationId: [],
  blockId: [],
  fieldId: [],
  padId: [],
  wellId: [],
  rigModelId: [],
  brigadeId: [],
  wellboreTypeInstanceId: []
}, Pt = 2, te = {
  showFact: !0,
  showPlan: !0,
  showWellbores: !0,
  showTrajectories: !0
}, un = { wells: [] };
function oe(i) {
  if (i.length === 0)
    return "unchecked";
  let e = !1, t = !1, n = !1;
  for (const r of i)
    r === "checked" ? e = !0 : r === "unchecked" ? t = !0 : n = !0;
  return n || e && t ? "intermediate" : e ? "checked" : "unchecked";
}
function hn(i, e) {
  return i.wells.find((t) => t.wellId === e);
}
function Dt(i, e) {
  return i == null ? void 0 : i.find((t) => t.wellboreId === e);
}
function fn(i, e) {
  return i == null ? void 0 : i.find((t) => t.designId === e);
}
function ye(i, e, t, n = !0) {
  const r = Dt(i, e);
  if (!r) return "unchecked";
  if (!n || r.trajectories.length === 0 || !t || t.length === 0)
    return "checked";
  const l = new Set(r.trajectories.map((o) => o.trajectoryId)), s = t.map((o) => l.has(o) ? "checked" : "unchecked");
  return oe(s);
}
function mn(i, e, t) {
  const n = Dt(i, e);
  return n && (n.trajectories.length === 0 || n.trajectories.some((r) => r.trajectoryId === t)) ? "checked" : "unchecked";
}
function Re(i, e, t, n = !0, r = !0) {
  const l = fn(i, e);
  if (!l) return "unchecked";
  if (!r || l.wellbores.length === 0 || !t || t.length === 0)
    return "checked";
  const s = t.map(
    (o) => ye(
      l.wellbores,
      o.id,
      o.trajectories.map((a) => a.id),
      n
    )
  );
  return oe(s);
}
function Le(i, e, t = te) {
  if (!t.showFact || !i || i.fact === void 0)
    return "unchecked";
  if (i.fact.length === 0 || !t.showWellbores)
    return "checked";
  const n = e == null ? void 0 : e.factWellbores;
  if (!n || n.length === 0)
    return "checked";
  const r = n.map(
    (l) => ye(
      i.fact,
      l.id,
      l.trajectories.map((s) => s.id),
      t.showTrajectories
    )
  );
  return oe(r);
}
function Be(i, e, t = te) {
  if (!t.showPlan || !i || i.plan === void 0)
    return "unchecked";
  if (i.plan.length === 0)
    return "checked";
  const n = e == null ? void 0 : e.planDesigns;
  if (!n || n.length === 0)
    return "checked";
  const r = n.map(
    (l) => Re(i.plan, l.id, l.wellbores, t.showTrajectories, t.showWellbores)
  );
  return oe(r);
}
function Oe(i, e, t, n = te) {
  const r = hn(i, e);
  if (!r) return "unchecked";
  const l = [];
  return n.showFact && l.push(Le(r, t, n)), n.showPlan && l.push(Be(r, t, n)), l.length === 0 ? "checked" : oe(l);
}
function bn(i, e, t, n = te) {
  if (e.length === 0)
    return "unchecked";
  const r = e.map((l) => Oe(i, l, t == null ? void 0 : t(l), n));
  return oe(r);
}
function B(i) {
  return i === "checked";
}
function J(i) {
  return i === "intermediate";
}
function le(i) {
  return i !== "unchecked";
}
function Ve(i) {
  return !i || !Array.isArray(i.wells) ? { wells: [] } : { wells: i.wells };
}
function N(i) {
  return structuredClone(Ve(i));
}
function Ie() {
  return N(un);
}
function ue(i) {
  return i ? {
    status: [...i.status],
    workStartDateFrom: i.workStartDateFrom,
    workStartDateTo: i.workStartDateTo,
    organizationId: [...i.organizationId],
    blockId: [...i.blockId],
    fieldId: [...i.fieldId],
    padId: [...i.padId],
    wellId: [...i.wellId],
    rigModelId: [...i.rigModelId],
    brigadeId: [...i.brigadeId],
    wellboreTypeInstanceId: [...i.wellboreTypeInstanceId]
  } : null;
}
function Y(i) {
  return Array.isArray(i) && i.every((e) => typeof e == "string" || typeof e == "number");
}
function gn(i) {
  if (i == null || !i || typeof i != "object")
    return null;
  const e = i, t = pn;
  return {
    status: Array.isArray(e.status) ? e.status.filter((n) => typeof n == "string") : [...t.status],
    workStartDateFrom: typeof e.workStartDateFrom == "number" ? e.workStartDateFrom : null,
    workStartDateTo: typeof e.workStartDateTo == "number" ? e.workStartDateTo : null,
    organizationId: Y(e.organizationId) ? [...e.organizationId] : [...t.organizationId],
    blockId: Y(e.blockId) ? [...e.blockId] : [...t.blockId],
    fieldId: Y(e.fieldId) ? [...e.fieldId] : [...t.fieldId],
    padId: Y(e.padId) ? [...e.padId] : [...t.padId],
    wellId: Y(e.wellId) ? [...e.wellId] : [...t.wellId],
    rigModelId: Y(e.rigModelId) ? [...e.rigModelId] : [...t.rigModelId],
    brigadeId: Y(e.brigadeId) ? [...e.brigadeId] : [...t.brigadeId],
    wellboreTypeInstanceId: Y(e.wellboreTypeInstanceId) ? [...e.wellboreTypeInstanceId] : [...t.wellboreTypeInstanceId]
  };
}
function he(i) {
  return i ? i.status.length === 0 && i.workStartDateFrom === null && i.workStartDateTo === null && i.organizationId.length === 0 && i.blockId.length === 0 && i.fieldId.length === 0 && i.padId.length === 0 && i.wellId.length === 0 && i.rigModelId.length === 0 && i.brigadeId.length === 0 && i.wellboreTypeInstanceId.length === 0 : !0;
}
function fe(i, e = null) {
  return {
    schemaVersion: Pt,
    tree: N(i),
    filters: ue(e)
  };
}
function me(i) {
  var t;
  if (!i || typeof i != "object")
    return {
      tree: Ie(),
      filters: null
    };
  const e = i;
  return e.schemaVersion === 1 ? {
    tree: N(e.tree),
    filters: null
  } : e.schemaVersion === Pt ? {
    tree: N(e.tree),
    filters: gn((t = e.filters) != null ? t : null)
  } : {
    tree: Ie(),
    filters: null
  };
}
function dl(i) {
  return me(i).tree;
}
function Et(i, e, t) {
  return e ? {
    wellboreId: i.wellboreId,
    trajectories: i.trajectories.map((n) => ({ trajectoryId: n.trajectoryId }))
  } : B(
    ye([i], i.wellboreId, t, !0)
  ) ? { wellboreId: i.wellboreId, trajectories: [] } : null;
}
function yn(i, e, t) {
  var r;
  if (i.wellbores.length === 0)
    return { designId: i.designId, wellbores: [] };
  const n = [];
  for (const l of i.wellbores) {
    const s = (r = t == null ? void 0 : t.find((a) => a.id === l.wellboreId)) == null ? void 0 : r.trajectories.map((a) => a.id), o = Et(l, e, s);
    o && n.push(o);
  }
  return n.length === 0 ? B(Re([i], i.designId, t, !0)) ? { designId: i.designId, wellbores: [] } : null : { designId: i.designId, wellbores: n };
}
function In(i, e, t) {
  var r, l;
  const n = { wellId: i.wellId };
  if (t.showFact && i.fact !== void 0)
    if (i.fact.length === 0)
      n.fact = [];
    else {
      const s = [];
      for (const o of i.fact) {
        const a = (r = e == null ? void 0 : e.factWellbores.find((u) => u.id === o.wellboreId)) == null ? void 0 : r.trajectories.map((u) => u.id), c = Et(o, t.showTrajectories, a);
        c && s.push(c);
      }
      s.length > 0 && (n.fact = s);
    }
  if (t.showPlan && i.plan !== void 0)
    if (i.plan.length === 0)
      n.plan = [];
    else {
      const s = [];
      for (const o of i.plan) {
        const a = (l = e == null ? void 0 : e.planDesigns.find((u) => u.id === o.designId)) == null ? void 0 : l.wellbores, c = yn(o, t.showTrajectories, a);
        c && s.push(c);
      }
      s.length > 0 && (n.plan = s);
    }
  return n.fact === void 0 && n.plan === void 0 ? !t.showFact && !t.showPlan ? n : null : n;
}
function Gt(i, e, t = te) {
  const n = Ve(i), r = [];
  for (const l of n.wells) {
    const s = In(l, e(l.wellId), t);
    s && r.push(s);
  }
  return { wells: r };
}
function be(i, e) {
  return i.trajectories.length > 0 ? {
    wellboreId: i.wellboreId,
    trajectories: i.trajectories.map((t) => ({ trajectoryId: t.trajectoryId }))
  } : {
    wellboreId: i.wellboreId,
    trajectories: e.map((t) => ({ trajectoryId: t }))
  };
}
function vn(i, e) {
  var n;
  const t = (n = e == null ? void 0 : e.factWellbores) != null ? n : [];
  return i.length === 0 ? t.map(
    (r) => be(
      { wellboreId: r.id, trajectories: [] },
      r.trajectories.map((l) => l.id)
    )
  ) : i.map((r) => {
    var s, o;
    const l = (o = (s = t.find((a) => a.id === r.wellboreId)) == null ? void 0 : s.trajectories.map((a) => a.id)) != null ? o : [];
    return be(r, l);
  });
}
function Sn(i, e) {
  var n;
  const t = (n = e == null ? void 0 : e.planDesigns) != null ? n : [];
  return i.length === 0 ? t.map((r) => ({
    designId: r.id,
    wellbores: r.wellbores.map(
      (l) => be(
        { wellboreId: l.id, trajectories: [] },
        l.trajectories.map((s) => s.id)
      )
    )
  })) : i.map((r) => {
    var o;
    const l = t.find((a) => a.id === r.designId), s = (o = l == null ? void 0 : l.wellbores) != null ? o : [];
    return r.wellbores.length === 0 ? {
      designId: r.designId,
      wellbores: s.map(
        (a) => be(
          { wellboreId: a.id, trajectories: [] },
          a.trajectories.map((c) => c.id)
        )
      )
    } : {
      designId: r.designId,
      wellbores: r.wellbores.map((a) => {
        var u, d;
        const c = (d = (u = s.find((h) => h.id === a.wellboreId)) == null ? void 0 : u.trajectories.map((h) => h.id)) != null ? d : [];
        return be(a, c);
      })
    };
  });
}
function wn(i, e, t = te) {
  const n = Ve(i), r = [];
  for (const l of n.wells) {
    const s = e(l.wellId), o = { wellId: l.wellId };
    t.showFact && l.fact !== void 0 && (o.fact = vn(l.fact, s)), t.showPlan && l.plan !== void 0 && (o.plan = Sn(l.plan, s)), !(o.fact === void 0 && o.plan === void 0) && r.push(o);
  }
  return { wells: r };
}
const _n = "applied-filters-section-module__root__OTZuV", Wn = "applied-filters-section-module__header__V9LXK", Tn = "applied-filters-section-module__expandIcon__cvZnP", Cn = "applied-filters-section-module__title__opcif", Fn = "applied-filters-section-module__chips__oocac", xn = "applied-filters-section-module__chip__pkpuw", Q = {
  root: _n,
  header: Wn,
  expandIcon: Tn,
  title: Cn,
  chips: Fn,
  chip: xn
};
function kn(i) {
  const e = typeof i == "number" ? i : Number(i);
  return Number.isFinite(e) ? e : null;
}
function Xe(i) {
  try {
    return new Date(i * 1e3).toLocaleDateString();
  } catch {
    return String(i);
  }
}
function Pn(i, e) {
  var n, r, l, s, o, a, c, u, d, h, m, f, S, w;
  const t = {
    organizationId: /* @__PURE__ */ new Map(),
    blockId: /* @__PURE__ */ new Map(),
    fieldId: /* @__PURE__ */ new Map(),
    padId: /* @__PURE__ */ new Map(),
    wellId: /* @__PURE__ */ new Map(),
    rigModelId: /* @__PURE__ */ new Map(),
    brigadeId: /* @__PURE__ */ new Map(),
    wellboreTypeInstanceId: /* @__PURE__ */ new Map()
  };
  for (const v of i) {
    t.wellId.set(v.id, v.name), ((n = v.organization) == null ? void 0 : n.id) != null && v.organization.name && t.organizationId.set(v.organization.id, v.organization.name), ((r = v.block) == null ? void 0 : r.organizationId) != null && ((l = v.organization) != null && l.name) && t.organizationId.set(v.block.organizationId, v.organization.name), ((s = v.block) == null ? void 0 : s.id) != null && v.block.name && t.blockId.set(v.block.id, v.block.name), ((o = v.field) == null ? void 0 : o.id) != null && v.field.name && t.fieldId.set(v.field.id, v.field.name);
    const M = (c = v.padId) != null ? c : (a = v.pad) == null ? void 0 : a.id, O = (h = (u = v.pad) == null ? void 0 : u.abbreviatedName) != null ? h : (d = v.pad) == null ? void 0 : d.name;
    M != null && O && t.padId.set(M, O), ((m = v.rigModel) == null ? void 0 : m.id) != null && v.rigModel.name && t.rigModelId.set(v.rigModel.id, v.rigModel.name);
    const ne = (S = v.brigadeId) != null ? S : (f = v.brigade) == null ? void 0 : f.id, E = (w = v.brigade) == null ? void 0 : w.name;
    ne != null && E && t.brigadeId.set(ne, E);
    const ae = e(v.id);
    if (ae) {
      for (const ie of ae.factWellbores)
        ie.typeInstanceId != null && ie.typeInstanceName && t.wellboreTypeInstanceId.set(ie.typeInstanceId, ie.typeInstanceName);
      for (const ie of ae.planDesigns)
        for (const we of ie.wellbores)
          we.typeInstanceId != null && we.typeInstanceName && t.wellboreTypeInstanceId.set(we.typeInstanceId, we.typeInstanceName);
    }
  }
  return t;
}
function Dn(i, e) {
  var n;
  const t = kn(i);
  return t == null ? String(i) : (n = e.get(t)) != null ? n : String(i);
}
function En(i, e, t) {
  if (!i || he(i))
    return [];
  const n = [];
  for (const l of i.status) {
    const s = l.toString().toUpperCase(), o = s === "ACTIVE" || s === "ACTIVE_GREEN" || s === "ACTIVE_YELLOW" || s === "ACTIVE_RED" ? t("Filters.statusActive") : s === "COMPLETED" ? t("Filters.statusCompleted") : String(l);
    n.push({ id: `status:${l}`, label: o });
  }
  i.workStartDateFrom !== null && n.push({ id: "workStartDateFrom", label: Xe(i.workStartDateFrom) }), i.workStartDateTo !== null && n.push({ id: "workStartDateTo", label: Xe(i.workStartDateTo) });
  const r = [
    "organizationId",
    "blockId",
    "fieldId",
    "padId",
    "wellId",
    "rigModelId",
    "brigadeId",
    "wellboreTypeInstanceId"
  ];
  for (const l of r)
    for (const s of i[l])
      n.push({
        id: `${l}:${s}`,
        label: Dn(s, e[l])
      });
  return n;
}
const Gn = L(function({ store: e }) {
  const { t } = j(), [n, r] = re(!0), l = Pn(e.wellsSourceAllWells, (o) => e.getWellChildren(o)), s = En(e.filters, l, t);
  return s.length === 0 ? null : /* @__PURE__ */ F("section", { className: Q.root, children: [
    /* @__PURE__ */ F(
      "button",
      {
        type: "button",
        className: Q.header,
        "aria-expanded": n,
        onClick: () => r((o) => !o),
        children: [
          n ? /* @__PURE__ */ p(Tt, { className: Q.expandIcon }) : /* @__PURE__ */ p(Ct, { className: Q.expandIcon }),
          /* @__PURE__ */ p("span", { className: D("dash-body-bold", Q.title), children: t("Filters.title") })
        ]
      }
    ),
    n && /* @__PURE__ */ p("div", { className: Q.chips, children: s.map((o) => /* @__PURE__ */ p("span", { className: D("dash-body-medium", Q.chip), children: o.label }, o.id)) })
  ] });
}), An = "group-action-list-module__list__KVSHC", jn = "group-action-list-module__listItem__2jJ3J", Nn = "group-action-list-module__listItemRegular__dQCDt", Mn = "group-action-list-module__listItemDangerous__hbMiN", Rn = "group-action-list-module__listItemDisabled__LOW51", ce = {
  list: An,
  listItem: jn,
  listItemRegular: Nn,
  listItemDangerous: Mn,
  listItemDisabled: Rn
};
function Ln({ actions: i }) {
  return /* @__PURE__ */ p("div", { className: D("dash-body-regular", ce.list), children: i.map(
    (e) => e && /* @__PURE__ */ p(
      "div",
      {
        className: D(
          ce.listItem,
          e.variant === "dangerous" ? ce.listItemDangerous : ce.listItemRegular,
          e.disabled && ce.listItemDisabled
        ),
        onClick: e.disabled ? void 0 : e.onClick,
        children: e.title
      },
      e.id
    )
  ) });
}
const Bn = "group-item-module__item__n8jHb", On = "group-item-module__itemActive__WbuDd", Vn = "group-item-module__name__iY5-P", $n = "group-item-module__menuButton__waoDQ", zn = "group-item-module__favoriteButton__uN6-t", Hn = "group-item-module__favoriteIcon__xA3r3", Un = "group-item-module__favoriteIconActive__mTBWP", Kn = "group-item-module__menuIcon__2Wqf1", X = {
  item: Bn,
  itemActive: On,
  name: Vn,
  menuButton: $n,
  favoriteButton: zn,
  favoriteIcon: Hn,
  favoriteIconActive: Un,
  menuIcon: Kn
}, Ze = L(function({ group: e, templatesStore: t, isActive: n = !1 }) {
  const { t: r } = j(), [l, s] = re(!1), o = e.visibility === "personal", a = ke(
    () => [
      {
        id: 0,
        title: r("GroupActions.apply"),
        onClick: () => {
          t.applyGroup(e.id, e.visibility), s(!1);
        }
      },
      {
        id: 1,
        title: r("GroupActions.rename"),
        onClick: () => {
          t.openRenameModal(e), s(!1);
        }
      },
      {
        id: 2,
        title: r(o ? "GroupActions.copyToPublic" : "GroupActions.copyToPersonal"),
        onClick: () => {
          t.duplicateGroup(e.id, e.visibility), s(!1);
        }
      },
      {
        id: 3,
        title: r("GroupActions.delete"),
        variant: "dangerous",
        onClick: () => {
          t.deleteGroup(e.id, e.visibility), s(!1);
        }
      }
    ],
    [e, o, r, t]
  ), c = (u) => {
    u.stopPropagation(), t.toggleGroupFavorite(e.id);
  };
  return /* @__PURE__ */ F("div", { className: D(X.item, n && X.itemActive), children: [
    /* @__PURE__ */ p(
      R,
      {
        type: "button",
        variant: "flat",
        size: "s",
        className: D("dash-body-regular", X.name),
        title: e.name,
        onClick: () => t.applyGroup(e.id, e.visibility),
        children: e.name
      }
    ),
    /* @__PURE__ */ p(
      R,
      {
        type: "button",
        variant: "flat",
        size: "s",
        className: X.favoriteButton,
        title: r(e.isFavorite ? "GroupActions.removeFavorite" : "GroupActions.addFavorite"),
        icon: e.isFavorite ? /* @__PURE__ */ p(Qt, { className: X.favoriteIconActive }) : /* @__PURE__ */ p(en, { className: X.favoriteIcon }),
        onClick: c
      }
    ),
    /* @__PURE__ */ p(
      Ht,
      {
        placement: "bottom-end",
        title: /* @__PURE__ */ p(Ln, { actions: a }),
        trigger: ["click"],
        open: l,
        onOpenChange: s,
        style: { paddingLeft: 0, paddingRight: 0 },
        withArrow: !1,
        children: /* @__PURE__ */ p(
          R,
          {
            type: "button",
            variant: "flat",
            size: "s",
            className: X.menuButton,
            title: r("GroupActions.menu"),
            icon: /* @__PURE__ */ p(tn, { className: X.menuIcon })
          }
        )
      }
    )
  ] });
}), Yn = "groups-tab-module__root__Jw7bf", Xn = "groups-tab-module__list__1fwo2", Zn = "groups-tab-module__empty__0jeFG", de = {
  root: Yn,
  list: Xn,
  empty: Zn
}, pl = "GOdashboard_ReferenceDataTemplates", At = 40, jt = 500, qn = "group-form-modal-module__body__-cyp0", Jn = "group-form-modal-module__modeRadios__Yr1-Z", Qn = "group-form-modal-module__radioRow__BXDbL", ei = "group-form-modal-module__actions__wAccO", ee = {
  body: qn,
  modeRadios: Jn,
  radioRow: Qn,
  actions: ei
}, ti = L(function({ templatesStore: e }) {
  const { t } = j(), n = e.renameTarget, [r, l] = re(""), [s, o] = re("");
  Me(() => {
    var c, u;
    l((c = n == null ? void 0 : n.name) != null ? c : ""), o((u = n == null ? void 0 : n.description) != null ? u : "");
  }, [n]);
  const a = r.trim().length > 0 && !e.isSaving;
  return /* @__PURE__ */ p(
    wt,
    {
      open: T(n),
      title: t("RenameModal.title"),
      onClose: e.closeRenameModal,
      style: { width: 440 },
      children: /* @__PURE__ */ F("div", { className: ee.body, children: [
        /* @__PURE__ */ p(ge, { label: t("GroupForm.name"), children: /* @__PURE__ */ p(
          Ne,
          {
            value: r,
            maxLength: At,
            disabled: e.isSaving,
            placeholder: t("GroupForm.namePlaceholder"),
            onChange: (c) => l(c.target.value)
          }
        ) }),
        /* @__PURE__ */ p(ge, { label: t("GroupForm.description"), children: /* @__PURE__ */ p(
          _t,
          {
            value: s,
            maxLength: jt,
            minRows: 1,
            maxRows: 5,
            disabled: e.isSaving,
            placeholder: t("GroupForm.descriptionPlaceholder"),
            style: { width: "100%", maxWidth: "100%" },
            onChange: o
          }
        ) }),
        /* @__PURE__ */ F("div", { className: ee.actions, children: [
          /* @__PURE__ */ p(
            R,
            {
              variant: "danger",
              icon: /* @__PURE__ */ p(Ft, {}),
              disabled: e.isSaving,
              onClick: e.closeRenameModal,
              children: t("GroupForm.cancel")
            }
          ),
          /* @__PURE__ */ p(
            R,
            {
              variant: "success",
              icon: /* @__PURE__ */ p(xt, {}),
              loading: e.isSaving,
              disabled: !a || !T(n),
              onClick: () => {
                T(n) && e.renameGroup(n.id, n.visibility, r, s);
              },
              children: t("GroupForm.save")
            }
          )
        ] })
      ] })
    }
  );
}), qe = {
  "--go-collapse-body-padding-right": 0,
  "--go-collapse-body-padding-left": 0,
  "--go-collapse-body-padding-top": "4px",
  "--go-collapse-body-padding-bottom": "8px"
}, ni = L(function({ templatesStore: e }) {
  const { t } = j(), { publicGroups: n, personalGroups: r, lastAppliedTemplateId: l, isLoading: s } = e;
  return /* @__PURE__ */ F("div", { className: de.root, children: [
    /* @__PURE__ */ p("div", { className: de.list, children: s ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", de.empty), children: t("Groups.loading") }) : /* @__PURE__ */ F(Ee, { defaultValue: ["Public", "Personal"], children: [
      /* @__PURE__ */ p(
        Ee.Panel,
        {
          header: t("Groups.public"),
          panelKey: "Public",
          styleWrapper: qe,
          stickyHeader: !0,
          children: n.length === 0 ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", de.empty), children: t("Groups.empty") }) : n.map((o) => /* @__PURE__ */ p(
            Ze,
            {
              group: o,
              templatesStore: e,
              isActive: l === o.id
            },
            o.id
          ))
        },
        "Public"
      ),
      /* @__PURE__ */ p(
        Ee.Panel,
        {
          header: t("Groups.personal"),
          panelKey: "Personal",
          styleWrapper: qe,
          stickyHeader: !0,
          children: r.length === 0 ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", de.empty), children: t("Groups.empty") }) : r.map((o) => /* @__PURE__ */ p(
            Ze,
            {
              group: o,
              templatesStore: e,
              isActive: l === o.id
            },
            o.id
          ))
        },
        "Personal"
      )
    ] }) }),
    /* @__PURE__ */ p(ti, { templatesStore: e })
  ] });
}), ii = "panel-footer-module__footer__BwXU9", ri = "panel-footer-module__selectionActions__ehWmp", li = "panel-footer-module__selectionButton__PXkJS", si = "panel-footer-module__saveButton__ZYZR2", oi = "panel-footer-module__icon__O8bIw", V = {
  footer: ii,
  selectionActions: ri,
  selectionButton: li,
  saveButton: si,
  icon: oi
}, ai = L(function({ store: e }) {
  var n;
  const { t } = j();
  return /* @__PURE__ */ F(q, { children: [
    /* @__PURE__ */ F("div", { className: ee.radioRow, children: [
      /* @__PURE__ */ p(
        Ce,
        {
          id: "ref-save-existing-personal",
          name: "ref-save-existing-visibility-personal",
          value: "personal",
          checked: e.existingVisibility === "personal",
          disabled: e.isSaving || e.personalDisabled,
          onChange: () => e.setExistingVisibility("personal"),
          children: t("SaveModal.personal")
        }
      ),
      /* @__PURE__ */ p(
        Ce,
        {
          id: "ref-save-existing-public",
          name: "ref-save-existing-visibility-public",
          value: "public",
          checked: e.existingVisibility === "public",
          disabled: e.isSaving || e.publicDisabled,
          onChange: () => e.setExistingVisibility("public"),
          children: t("SaveModal.public")
        }
      )
    ] }),
    /* @__PURE__ */ p(ge, { label: t("SaveModal.group"), children: /* @__PURE__ */ p(
      Ut,
      {
        value: (n = e.selectedGroupId) != null ? n : void 0,
        disabled: e.isExistingSelectDisabled,
        placeholder: t("SaveModal.groupPlaceholder"),
        options: e.existingOptions,
        onChange: e.onSelectedGroupChange
      }
    ) })
  ] });
}), ci = L(function({ store: e }) {
  const { t } = j();
  return /* @__PURE__ */ F(q, { children: [
    /* @__PURE__ */ F("div", { className: ee.radioRow, children: [
      /* @__PURE__ */ p(
        Ce,
        {
          id: "ref-save-new-personal",
          name: "ref-save-new-visibility-personal",
          value: "personal",
          checked: e.newVisibility === "personal",
          disabled: e.isSaving,
          onChange: () => e.setNewVisibility("personal"),
          children: t("SaveModal.personal")
        }
      ),
      /* @__PURE__ */ p(
        Ce,
        {
          id: "ref-save-new-public",
          name: "ref-save-new-visibility-public",
          value: "public",
          checked: e.newVisibility === "public",
          disabled: e.isSaving,
          onChange: () => e.setNewVisibility("public"),
          children: t("SaveModal.public")
        }
      )
    ] }),
    /* @__PURE__ */ p(ge, { label: t("GroupForm.name"), children: /* @__PURE__ */ p(
      Ne,
      {
        value: e.name,
        maxLength: e.maxNameLength,
        disabled: e.isSaving,
        placeholder: t("GroupForm.namePlaceholder"),
        onChange: e.onNameInputChange
      }
    ) }),
    /* @__PURE__ */ p(ge, { label: t("GroupForm.description"), children: /* @__PURE__ */ p(
      _t,
      {
        value: e.description,
        maxLength: e.maxDescriptionLength,
        minRows: 1,
        maxRows: 5,
        disabled: e.isSaving,
        placeholder: t("GroupForm.descriptionPlaceholder"),
        style: { width: "100%", maxWidth: "100%" },
        onChange: e.onDescriptionChange
      }
    ) })
  ] });
});
var di = Object.defineProperty, pi = Object.getOwnPropertyDescriptor, x = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? pi(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && di(e, t, r), r;
};
class C {
  constructor(e) {
    I(this, "templatesStore");
    I(this, "disposers", []);
    I(this, "maxNameLength", At);
    I(this, "maxDescriptionLength", jt);
    I(this, "mode", "new");
    I(this, "name", "");
    I(this, "description", "");
    I(this, "newVisibility", "personal");
    I(this, "existingVisibility", "personal");
    I(this, "selectedGroupId", null);
    this.templatesStore = e, Se(this), this.disposers.push(
      Ge(
        () => this.templatesStore.saveModalOpen,
        (t) => {
          t && this.reset();
        }
      ),
      Ge(
        () => ({
          open: this.templatesStore.saveModalOpen,
          mode: this.mode,
          personalCount: this.templatesStore.personalGroups.length,
          publicCount: this.templatesStore.publicGroups.length,
          existingVisibility: this.existingVisibility
        }),
        () => this.syncExistingVisibility()
      ),
      Ge(
        () => ({
          open: this.templatesStore.saveModalOpen,
          mode: this.mode,
          optionIds: this.existingOptions.map((t) => t.value).join(","),
          selectedGroupId: this.selectedGroupId
        }),
        () => this.syncSelectedGroupId()
      )
    );
  }
  dispose() {
    for (const e of this.disposers)
      e();
    this.disposers.length = 0;
  }
  get isOpen() {
    return this.templatesStore.saveModalOpen;
  }
  get isSaving() {
    return this.templatesStore.isSaving;
  }
  get hasAnyGroups() {
    return this.templatesStore.hasAnyGroups;
  }
  get effectiveMode() {
    return this.hasAnyGroups ? this.mode : "new";
  }
  get isNewMode() {
    return this.effectiveMode === "new";
  }
  get personalDisabled() {
    return this.templatesStore.personalGroups.length === 0;
  }
  get publicDisabled() {
    return this.templatesStore.publicGroups.length === 0;
  }
  get existingOptions() {
    return (this.existingVisibility === "personal" ? this.templatesStore.personalGroups : this.templatesStore.publicGroups).map((t) => ({ value: t.id, label: t.name }));
  }
  get isExistingSelectDisabled() {
    return this.isSaving || this.existingOptions.length === 0;
  }
  get canSubmit() {
    return this.isSaving ? !1 : this.isNewMode ? this.name.trim().length > 0 : T(this.selectedGroupId);
  }
  setMode(e) {
    this.mode = e;
  }
  setNewVisibility(e) {
    this.newVisibility = e;
  }
  setExistingVisibility(e) {
    this.existingVisibility = e;
  }
  onNameInputChange(e) {
    this.name = e.target.value;
  }
  onDescriptionChange(e) {
    this.description = e;
  }
  onSelectedGroupChange(e) {
    this.selectedGroupId = typeof e == "string" ? e : null;
  }
  close() {
    this.templatesStore.closeSaveModal();
  }
  submit() {
    if (this.canSubmit) {
      if (this.isNewMode) {
        this.templatesStore.createGroupFromCurrentSelection(this.name, this.newVisibility, this.description);
        return;
      }
      T(this.selectedGroupId) && this.templatesStore.updateGroupWithCurrentTree(this.selectedGroupId, this.existingVisibility);
    }
  }
  reset() {
    this.mode = "new", this.name = "", this.description = "", this.newVisibility = "personal", this.selectedGroupId = null, this.templatesStore.personalGroups.length > 0 ? this.existingVisibility = "personal" : this.templatesStore.publicGroups.length > 0 ? this.existingVisibility = "public" : this.existingVisibility = "personal";
  }
  syncExistingVisibility() {
    if (!this.templatesStore.saveModalOpen || this.mode !== "existing")
      return;
    const { personalGroups: e, publicGroups: t } = this.templatesStore;
    this.existingVisibility === "personal" && e.length === 0 && t.length > 0 && (this.existingVisibility = "public"), this.existingVisibility === "public" && t.length === 0 && e.length > 0 && (this.existingVisibility = "personal");
  }
  syncSelectedGroupId() {
    var e, t;
    !this.templatesStore.saveModalOpen || this.mode !== "existing" || (!this.selectedGroupId || !this.existingOptions.some((n) => n.value === this.selectedGroupId)) && (this.selectedGroupId = (t = (e = this.existingOptions[0]) == null ? void 0 : e.value) != null ? t : null);
  }
}
x([
  W
], C.prototype, "mode", 2);
x([
  W
], C.prototype, "name", 2);
x([
  W
], C.prototype, "description", 2);
x([
  W
], C.prototype, "newVisibility", 2);
x([
  W
], C.prototype, "existingVisibility", 2);
x([
  W
], C.prototype, "selectedGroupId", 2);
x([
  _
], C.prototype, "isOpen", 1);
x([
  _
], C.prototype, "isSaving", 1);
x([
  _
], C.prototype, "hasAnyGroups", 1);
x([
  _
], C.prototype, "effectiveMode", 1);
x([
  _
], C.prototype, "isNewMode", 1);
x([
  _
], C.prototype, "personalDisabled", 1);
x([
  _
], C.prototype, "publicDisabled", 1);
x([
  _
], C.prototype, "existingOptions", 1);
x([
  _
], C.prototype, "isExistingSelectDisabled", 1);
x([
  _
], C.prototype, "canSubmit", 1);
x([
  y.bound
], C.prototype, "setMode", 1);
x([
  y.bound
], C.prototype, "setNewVisibility", 1);
x([
  y.bound
], C.prototype, "setExistingVisibility", 1);
x([
  y.bound
], C.prototype, "onNameInputChange", 1);
x([
  y.bound
], C.prototype, "onDescriptionChange", 1);
x([
  y.bound
], C.prototype, "onSelectedGroupChange", 1);
x([
  y.bound
], C.prototype, "close", 1);
x([
  y.bound
], C.prototype, "submit", 1);
x([
  y
], C.prototype, "reset", 1);
x([
  y
], C.prototype, "syncExistingVisibility", 1);
x([
  y
], C.prototype, "syncSelectedGroupId", 1);
const ui = L(function({ templatesStore: e }) {
  const { t } = j(), [n] = re(() => new C(e));
  Me(() => () => n.dispose(), [n]);
  const r = ke(
    () => [
      { value: "new", label: t("SaveModal.modeNew") },
      { value: "existing", label: t("SaveModal.modeExisting") }
    ],
    [t]
  );
  return /* @__PURE__ */ p(wt, { open: n.isOpen, title: t("SaveModal.title"), onClose: n.close, style: { width: 440 }, children: /* @__PURE__ */ F("div", { className: ee.body, children: [
    n.hasAnyGroups && /* @__PURE__ */ p(
      Wt,
      {
        size: "s",
        value: n.mode,
        items: r,
        onChange: n.setMode,
        className: ee.modeRadios
      }
    ),
    n.isNewMode ? /* @__PURE__ */ p(ci, { store: n }) : /* @__PURE__ */ p(ai, { store: n }),
    /* @__PURE__ */ F("div", { className: ee.actions, children: [
      /* @__PURE__ */ p(R, { variant: "danger", icon: /* @__PURE__ */ p(Ft, {}), disabled: n.isSaving, onClick: n.close, children: t("GroupForm.cancel") }),
      /* @__PURE__ */ p(
        R,
        {
          variant: "success",
          icon: /* @__PURE__ */ p(xt, {}),
          loading: n.isSaving,
          disabled: !n.canSubmit,
          onClick: n.submit,
          children: t("GroupForm.save")
        }
      )
    ] })
  ] }) });
}), hi = L(function({ store: e, templatesStore: t }) {
  const { t: n } = j(), r = e.hasPendingSelectionChanges, l = !e.hasFiltersHost;
  return /* @__PURE__ */ F(q, { children: [
    /* @__PURE__ */ F("footer", { className: V.footer, children: [
      r && /* @__PURE__ */ F("div", { className: V.selectionActions, children: [
        /* @__PURE__ */ p(
          R,
          {
            variant: "primary",
            size: "m",
            className: D(V.selectionButton, "dash-body-medium"),
            onClick: e.applyDraftSelection,
            children: n("Footer.apply")
          }
        ),
        /* @__PURE__ */ p(
          R,
          {
            variant: "secondary",
            size: "m",
            className: D(V.selectionButton, "dash-body-medium"),
            onClick: e.resetDraftSelection,
            children: n("Footer.cancel")
          }
        )
      ] }),
      /* @__PURE__ */ F("div", { className: V.selectionActions, children: [
        /* @__PURE__ */ p(
          R,
          {
            variant: "secondary",
            size: "m",
            className: D(V.selectionButton, "dash-body-medium"),
            icon: /* @__PURE__ */ p(nn, { className: V.icon }),
            disabled: l,
            onClick: e.importFiltersFromHost,
            children: n("Footer.filter")
          }
        ),
        /* @__PURE__ */ p(
          R,
          {
            variant: "secondary",
            size: "m",
            className: D(V.selectionButton, "dash-body-medium"),
            icon: /* @__PURE__ */ p(rn, { className: V.icon }),
            disabled: l,
            onClick: e.exportFiltersToHost,
            children: n("Footer.exportFilters")
          }
        )
      ] }),
      /* @__PURE__ */ p(
        R,
        {
          variant: "success",
          size: "m",
          className: D(V.saveButton, "dash-body-medium"),
          icon: /* @__PURE__ */ p(ln, { className: V.icon }),
          disabled: !t.canCreate || t.isSaving,
          loading: t.isSaving && t.saveModalOpen,
          onClick: t.openSaveModal,
          children: n("Footer.save")
        }
      )
    ] }),
    /* @__PURE__ */ p(ui, { templatesStore: t })
  ] });
}), fi = "panel-header-module__header__4FeMz", mi = "panel-header-module__title__jygu3", bi = "panel-header-module__closeButton__kGfqu", gi = "panel-header-module__closeIcon__5sTbF", _e = {
  header: fi,
  title: mi,
  closeButton: bi,
  closeIcon: gi
};
function yi({ title: i, onClose: e }) {
  const { t } = j();
  return /* @__PURE__ */ F("header", { className: _e.header, children: [
    /* @__PURE__ */ p("span", { className: D("h3", _e.title), children: i }),
    T(e) && /* @__PURE__ */ p(
      R,
      {
        variant: "flat",
        className: _e.closeButton,
        icon: /* @__PURE__ */ p(sn, { className: _e.closeIcon }),
        title: t("Header.close"),
        onClick: e
      }
    )
  ] });
}
const Ii = "search-bar-module__root__uqd6I", vi = "search-bar-module__icon__85Cf9", Si = "search-bar-module__input__GfsSf", Ae = {
  root: Ii,
  icon: vi,
  input: Si
}, wi = L(function({ store: e }) {
  const { t } = j();
  return /* @__PURE__ */ p("div", { className: Ae.root, children: /* @__PURE__ */ p(
    Ne,
    {
      allowClear: !0,
      prefix: /* @__PURE__ */ p(on, { className: Ae.icon }),
      value: e.searchValue,
      inputClassName: Ae.input,
      placeholder: t("Panel.searchPlaceholder"),
      onChange: (n) => e.setSearchValue(n.target.value)
    }
  ) });
}), _i = "tree-node-module__row__0068d", Wi = "tree-node-module__checkbox__T-lzz", Ti = "tree-node-module__expandHitArea__tB7cl", Ci = "tree-node-module__labelGroup__56zEE", Fi = "tree-node-module__expandButton__697Gr", xi = "tree-node-module__expandIcon__z6nrC", ki = "tree-node-module__statusIcon__Uf2oI", Pi = "tree-node-module__labelWithTrailing__9OEcT", Di = "tree-node-module__label__ExS4n", Ei = "tree-node-module__children__kV9sb", z = {
  row: _i,
  checkbox: Wi,
  expandHitArea: Ti,
  labelGroup: Ci,
  expandButton: Fi,
  expandIcon: xi,
  statusIcon: ki,
  labelWithTrailing: Pi,
  label: Di,
  children: Ei
};
function H({
  label: i,
  checked: e = !1,
  intermediate: t = !1,
  expanded: n,
  bold: r = !1,
  disabled: l = !1,
  expandable: s = !1,
  icon: o,
  trailing: a,
  children: c,
  onCheckedChange: u,
  onExpandToggle: d
}) {
  const { t: h } = j(), m = s, f = D(r ? "dash-body-bold" : "dash-body-regular", z.label), S = n ? /* @__PURE__ */ p(Tt, { className: z.expandIcon }) : /* @__PURE__ */ p(Ct, { className: z.expandIcon }), w = /* @__PURE__ */ F(q, { children: [
    m && /* @__PURE__ */ p("span", { className: z.expandButton, children: S }),
    o,
    /* @__PURE__ */ F("span", { className: z.labelWithTrailing, children: [
      /* @__PURE__ */ p("span", { className: f, children: i }),
      a
    ] })
  ] });
  return /* @__PURE__ */ F(q, { children: [
    /* @__PURE__ */ F("div", { className: z.row, children: [
      /* @__PURE__ */ p(
        Kt,
        {
          checked: e,
          intermediate: t,
          size: "s",
          disabled: l,
          className: z.checkbox,
          onChange: u
        }
      ),
      m ? /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          className: z.expandHitArea,
          title: h(n ? "Tree.collapse" : "Tree.expand"),
          onClick: d,
          children: w
        }
      ) : /* @__PURE__ */ p("div", { className: z.labelGroup, children: w })
    ] }),
    s && n && /* @__PURE__ */ p("div", { className: z.children, children: c })
  ] });
}
function Je({ status: i }) {
  return /* @__PURE__ */ p(an, { className: z.statusIcon, style: { color: Xt(i) } });
}
function Gi(i) {
  return i ? {
    wellId: i.wellId,
    branch: i.branch,
    designId: i.designId,
    wellboreId: i.wellboreId,
    trajectoryId: i.trajectoryId
  } : null;
}
function Nt(i, e) {
  return !i && !e ? !0 : !i || !e ? !1 : i.wellId === e.wellId && i.branch === e.branch && i.designId === e.designId && i.wellboreId === e.wellboreId && i.trajectoryId === e.trajectoryId;
}
function ve(i, e, t, n, r) {
  return !i || i.wellId !== e || i.branch !== t || i.wellboreId !== n ? !1 : t === "plan" ? i.designId === r : !0;
}
function $e(i, e, t, n, r, l) {
  return T(i == null ? void 0 : i.trajectoryId) ? ve(i, e, t, n, l) && i.trajectoryId === r : !1;
}
function Mt(i, e) {
  return !!i && i.wellId === e && i.branch === "fact";
}
function ze(i, e) {
  return !!i && i.wellId === e && i.branch === "plan";
}
function Rt(i, e, t) {
  return ze(i, e) && (i == null ? void 0 : i.designId) === t;
}
function He(i, e) {
  var t;
  return i.fact === void 0 ? [] : i.fact.length === 0 ? ((t = e == null ? void 0 : e.factWellbores) != null ? t : []).map((n) => ({ wellboreId: n.id, trajectories: [] })) : i.fact.map((n) => structuredClone(n));
}
function Ue(i, e) {
  var t;
  return i.plan === void 0 ? [] : i.plan.length === 0 ? ((t = e == null ? void 0 : e.planDesigns) != null ? t : []).map((n) => ({ designId: n.id, wellbores: [] })) : i.plan.map((n) => structuredClone(n));
}
function Lt(i, e) {
  return i.trajectories.length === 0 ? [...e] : i.trajectories.map((t) => t.trajectoryId);
}
function Qe(i, e) {
  return i.filter((t) => t.wellboreId !== e);
}
function et(i, e, t, n) {
  const r = i.find((a) => a.wellboreId === e);
  if (!r)
    return i;
  const l = new Set(Lt(r, n));
  l.delete(t);
  const s = i.filter((a) => a.wellboreId !== e);
  if (l.size === 0)
    return s;
  const o = n.length > 0 && l.size === n.length ? [] : Array.from(l).map((a) => ({ trajectoryId: a }));
  return s.push({ wellboreId: e, trajectories: o }), s;
}
function tt(i, e, t, n) {
  const r = i.find((a) => a.wellboreId === e), l = new Set(r ? Lt(r, n) : []);
  l.add(t);
  const s = i.filter((a) => a.wellboreId !== e), o = n.length > 0 && l.size === n.length ? [] : Array.from(l).map((a) => ({ trajectoryId: a }));
  return s.push({ wellboreId: e, trajectories: o }), s;
}
function Bt(i, e) {
  var t, n;
  return (n = (t = i == null ? void 0 : i.factWellbores.find((r) => r.id === e)) == null ? void 0 : t.trajectories.map((r) => r.id)) != null ? n : [];
}
function Ot(i, e, t) {
  var n, r, l;
  return (l = (r = (n = i == null ? void 0 : i.planDesigns.find((s) => s.id === e)) == null ? void 0 : n.wellbores.find((s) => s.id === t)) == null ? void 0 : r.trajectories.map((s) => s.id)) != null ? l : [];
}
function Ai(i, e, t) {
  var u;
  const n = structuredClone(i);
  if (e.branch === "fact") {
    if (n.fact === void 0)
      return n;
    const d = He(n, t), h = Qe(d, e.wellboreId);
    if (h.length === 0)
      delete n.fact;
    else if (t && h.length === t.factWellbores.length) {
      const m = h.every((f) => f.trajectories.length === 0);
      n.fact = m ? [] : h;
    } else
      n.fact = h;
    return n;
  }
  if (n.plan === void 0 || !T(e.designId))
    return n;
  const r = Ue(n, t), l = r.find((d) => d.designId === e.designId), s = t == null ? void 0 : t.planDesigns.find((d) => d.id === e.designId);
  if (!l)
    return n;
  const o = l.wellbores.length === 0 ? (u = s == null ? void 0 : s.wellbores.map((d) => ({
    wellboreId: d.id,
    trajectories: []
  }))) != null ? u : [] : l.wellbores, a = Qe(o, e.wellboreId), c = r.filter((d) => d.designId !== e.designId);
  if (a.length === 0)
    return c.length === 0 ? delete n.plan : n.plan = c, n;
  if (c.push({ designId: e.designId, wellbores: a }), t && c.length === t.planDesigns.length) {
    const d = c.every((h) => h.wellbores.length === 0);
    n.plan = d ? [] : c;
  } else
    n.plan = c;
  return n;
}
function nt(i, e) {
  return i.find((n) => n.wellboreId === e) ? i : [...i, { wellboreId: e, trajectories: [] }];
}
function Vt(i, e, t) {
  var u;
  const n = structuredClone(i);
  if (e.branch === "fact") {
    const d = He(n, t), h = T(e.trajectoryId) ? tt(
      d,
      e.wellboreId,
      e.trajectoryId,
      Bt(t, e.wellboreId)
    ) : nt(d, e.wellboreId);
    if (t && h.length === t.factWellbores.length) {
      const m = h.every((f) => f.trajectories.length === 0);
      n.fact = m ? [] : h;
    } else
      n.fact = h;
    return n;
  }
  if (!T(e.designId))
    return n;
  const r = Ue(n, t), l = t == null ? void 0 : t.planDesigns.find((d) => d.id === e.designId), s = r.find((d) => d.designId === e.designId), o = s ? s.wellbores.length === 0 ? (u = l == null ? void 0 : l.wellbores.map((d) => ({
    wellboreId: d.id,
    trajectories: []
  }))) != null ? u : [] : s.wellbores.map((d) => structuredClone(d)) : [], a = T(e.trajectoryId) ? tt(
    o,
    e.wellboreId,
    e.trajectoryId,
    Ot(t, e.designId, e.wellboreId)
  ) : nt(o, e.wellboreId), c = r.filter((d) => d.designId !== e.designId);
  if (c.push({ designId: e.designId, wellbores: a }), t && c.length === t.planDesigns.length) {
    const d = c.every((h) => h.wellbores.length === 0);
    n.plan = d ? [] : c;
  } else
    n.plan = c;
  return n;
}
function Ke(i, e, t, n) {
  const l = N(i).wells.map((o) => structuredClone(o)), s = e && t && e.wellId === t.wellId && e.branch === t.branch && e.designId === t.designId && e.wellboreId === t.wellboreId;
  if (e && !Nt(e, t)) {
    const o = l.findIndex((a) => a.wellId === e.wellId);
    o >= 0 && (s ? l[o] = ji(l[o], e, n(e.wellId)) : l[o] = Ai(l[o], e, n(e.wellId)));
  }
  if (t) {
    let o = l.findIndex((a) => a.wellId === t.wellId);
    o < 0 && (l.push({ wellId: t.wellId }), o = l.length - 1), l[o] = Vt(l[o], t, n(t.wellId));
  }
  return {
    wells: l.filter((o) => o.fact !== void 0 || o.plan !== void 0)
  };
}
function ji(i, e, t) {
  var h;
  if (!T(e.trajectoryId))
    return i;
  const n = structuredClone(i), r = e.trajectoryId;
  if (e.branch === "fact") {
    if (n.fact === void 0)
      return n;
    const m = He(n, t), f = Bt(t, e.wellboreId), S = et(m, e.wellboreId, r, f);
    if (S.length === 0)
      delete n.fact;
    else if (t && S.length === t.factWellbores.length) {
      const w = S.every((v) => v.trajectories.length === 0);
      n.fact = w ? [] : S;
    } else
      n.fact = S;
    return n;
  }
  if (n.plan === void 0 || !T(e.designId))
    return n;
  const l = Ue(n, t), s = l.find((m) => m.designId === e.designId), o = t == null ? void 0 : t.planDesigns.find((m) => m.id === e.designId);
  if (!s)
    return n;
  const a = s.wellbores.length === 0 ? (h = o == null ? void 0 : o.wellbores.map((m) => ({
    wellboreId: m.id,
    trajectories: []
  }))) != null ? h : [] : s.wellbores, c = Ot(t, e.designId, e.wellboreId), u = et(a, e.wellboreId, r, c), d = l.filter((m) => m.designId !== e.designId);
  if (u.length === 0)
    return d.length === 0 ? delete n.plan : n.plan = d, n;
  if (d.push({ designId: e.designId, wellbores: u }), t && d.length === t.planDesigns.length) {
    const m = d.every((f) => f.wellbores.length === 0);
    n.plan = m ? [] : d;
  } else
    n.plan = d;
  return n;
}
function Ni(i, e, t) {
  return e ? Ke(i, null, e, t) : N(i);
}
function it(i, e, t) {
  return !e || e.wellId !== i.wellId ? i : Vt(i, e, t);
}
const Mi = "active-status-icon-module__wrap__QpGQJ", Ri = "active-status-icon-module__icon__KxppE", rt = {
  wrap: Mi,
  icon: Ri
};
function Li({ className: i }) {
  const { t: e } = j(), t = e("Filters.statusActive");
  return /* @__PURE__ */ p("span", { className: D(rt.wrap, i), title: t, "aria-label": t, children: /* @__PURE__ */ p(cn, { className: rt.icon }) });
}
const Bi = "redrilling-badge-module__badge__mnr97", Oi = {
  badge: Bi
};
function Vi({ redrillingIndex: i, backgroundColor: e, className: t }) {
  const { t: n } = j();
  return /* @__PURE__ */ F(
    "span",
    {
      className: D("dash-body-regular", Oi.badge, t),
      style: e ? { backgroundColor: e } : void 0,
      children: [
        n("Panel.redrill"),
        " ",
        i
      ]
    }
  );
}
const $i = [
  "rgba(255, 105, 180, 0.3)",
  "rgba(111, 207, 151, 0.3)",
  "rgba(125, 168, 255, 0.3)",
  "rgba(242, 153, 74, 0.3)",
  "rgba(155, 89, 182, 0.3)",
  "rgba(38, 198, 218, 0.3)",
  "rgba(255, 214, 102, 0.3)",
  "rgba(235, 87, 87, 0.3)",
  "rgba(178, 136, 255, 0.3)",
  "rgba(168, 196, 88, 0.3)"
];
function zi(i) {
  var n;
  const e = $i;
  if (e.length === 0)
    return "transparent";
  const t = Math.max(0, i) % e.length;
  return (n = e[t]) != null ? n : e[0];
}
function Hi(i) {
  const e = /* @__PURE__ */ new Map();
  for (const r of i) {
    if (!T(r.redrillingIndex) || r.typeInstanceId == null)
      continue;
    const l = e.get(r.typeInstanceId);
    (!l || r.typeIndex < l.typeIndex) && e.set(r.typeInstanceId, { typeIndex: r.typeIndex });
  }
  const t = [...e.entries()].sort((r, l) => {
    const s = r[1].typeIndex - l[1].typeIndex;
    return s !== 0 ? s : r[0] - l[0];
  }).map(([r]) => r), n = /* @__PURE__ */ new Map();
  return t.forEach((r, l) => {
    n.set(r, zi(l));
  }), n;
}
function Fe(i) {
  const { isActive: e, redrillBadge: t } = i;
  if (!(!t && !e))
    return /* @__PURE__ */ F(q, { children: [
      t,
      e ? /* @__PURE__ */ p(Li, {}) : null
    ] });
}
const lt = L(function({
  store: e,
  wellId: t,
  wellbores: n,
  disabled: r,
  forced: l,
  redrillingColorsByTypeInstanceId: s
}) {
  return n.map(({ wellbore: o, checkState: a, trajectories: c }) => {
    const u = ve(l, t, "fact", o.id), d = r || u, h = o.typeInstanceId != null ? s.get(o.typeInstanceId) : void 0, m = T(o.redrillingIndex) ? /* @__PURE__ */ p(Vi, { redrillingIndex: o.redrillingIndex, backgroundColor: h }) : void 0;
    return /* @__PURE__ */ p(
      H,
      {
        label: o.name,
        checked: B(a) || u,
        intermediate: J(a) && !u,
        disabled: d,
        expandable: c.length > 0,
        expanded: e.isWellboreExpanded(t, "fact", o.id),
        trailing: Fe({ isActive: o.isActive, redrillBadge: m }),
        onCheckedChange: d ? void 0 : (f) => e.setFactWellboreChecked(t, o.id, f),
        onExpandToggle: () => e.toggleWellboreExpanded(t, "fact", o.id),
        children: c.map(({ trajectory: f, checkState: S }) => {
          const w = $e(l, t, "fact", o.id, f.id), v = r || w;
          return /* @__PURE__ */ p(
            H,
            {
              label: f.name,
              checked: B(S) || w,
              disabled: v,
              trailing: Fe({ isActive: f.isActive }),
              onCheckedChange: v ? void 0 : (M) => e.setFactTrajectoryChecked(t, o.id, f.id, M)
            },
            `fact-traj-${f.id}`
          );
        })
      },
      `fact-wb-${o.id}`
    );
  });
}), st = L(function({
  store: e,
  wellId: t,
  designs: n,
  disabled: r,
  forced: l
}) {
  return n.map(({ design: s, checkState: o, wellbores: a }) => {
    const c = Rt(l, t, s.id), u = r || c;
    return /* @__PURE__ */ p(
      H,
      {
        label: s.name,
        checked: B(o) || c,
        intermediate: J(o) && !c,
        disabled: u,
        expandable: a.length > 0,
        expanded: e.isDesignExpanded(t, s.id),
        onCheckedChange: u ? void 0 : (d) => e.setDesignChecked(t, s.id, d),
        onExpandToggle: () => e.toggleDesignExpanded(t, s.id),
        children: a.map(({ wellbore: d, checkState: h, trajectories: m }) => {
          const f = ve(l, t, "plan", d.id, s.id), S = r || f;
          return /* @__PURE__ */ p(
            H,
            {
              label: d.name,
              checked: B(h) || f,
              intermediate: J(h) && !f,
              disabled: S,
              expandable: m.length > 0,
              expanded: e.isWellboreExpanded(t, "plan", d.id, s.id),
              trailing: Fe({ isActive: d.isActive }),
              onCheckedChange: S ? void 0 : (w) => e.setPlanWellboreChecked(t, s.id, d.id, w),
              onExpandToggle: () => e.toggleWellboreExpanded(t, "plan", d.id, s.id),
              children: m.map(({ trajectory: w, checkState: v }) => {
                const M = $e(
                  l,
                  t,
                  "plan",
                  d.id,
                  w.id,
                  s.id
                ), O = r || M;
                return /* @__PURE__ */ p(
                  H,
                  {
                    label: w.name,
                    checked: B(v) || M,
                    disabled: O,
                    trailing: Fe({ isActive: w.isActive }),
                    onCheckedChange: O ? void 0 : (ne) => e.setPlanTrajectoryChecked(t, s.id, d.id, w.id, ne)
                  },
                  `plan-traj-${s.id}-${w.id}`
                );
              })
            },
            `plan-wb-${s.id}-${d.id}`
          );
        })
      },
      `design-${s.id}`
    );
  });
}), ot = L(function({
  store: e,
  wellId: t,
  planCheckState: n,
  factCheckState: r,
  disabled: l = !1
}) {
  var v, M;
  const { t: s } = j(), { fact: o, plan: a, showFactGroup: c, showPlanGroup: u } = e.getVisibleWellBranch(t), d = e.forcedPrimarySelection, h = Hi(
    (M = (v = e.getWellChildren(t)) == null ? void 0 : v.factWellbores) != null ? M : []
  ), m = Mt(d, t), f = ze(d, t), S = l || m, w = l || f;
  return /* @__PURE__ */ F(q, { children: [
    o !== null && (c ? /* @__PURE__ */ p(
      H,
      {
        label: s("Panel.fact"),
        checked: B(r) || m,
        intermediate: J(r) && !m,
        disabled: S,
        expandable: o.length > 0,
        expanded: e.isFactExpanded(t),
        onCheckedChange: S ? void 0 : (O) => e.setFactChecked(t, O),
        onExpandToggle: () => e.toggleFactExpanded(t),
        children: /* @__PURE__ */ p(
          lt,
          {
            store: e,
            wellId: t,
            wellbores: o,
            disabled: l,
            forced: d,
            redrillingColorsByTypeInstanceId: h
          }
        )
      }
    ) : /* @__PURE__ */ p(
      lt,
      {
        store: e,
        wellId: t,
        wellbores: o,
        disabled: l,
        forced: d,
        redrillingColorsByTypeInstanceId: h
      }
    )),
    a !== null && (u ? /* @__PURE__ */ p(
      H,
      {
        label: s("Panel.plan"),
        checked: B(n) || f,
        intermediate: J(n) && !f,
        disabled: w,
        expandable: a.length > 0,
        expanded: e.isPlanExpanded(t),
        onCheckedChange: w ? void 0 : (O) => e.setPlanChecked(t, O),
        onExpandToggle: () => e.togglePlanExpanded(t),
        children: /* @__PURE__ */ p(st, { store: e, wellId: t, designs: a, disabled: l, forced: d })
      }
    ) : /* @__PURE__ */ p(st, { store: e, wellId: t, designs: a, disabled: l, forced: d }))
  ] });
}), Ui = { title: "Offset wells", tabWells: "Wells", tabGroups: "Groups", primaryWell: "Active well", plan: "Plan", fact: "Fact", loading: "Loading…", all: "Offset wells", emptyNameFallback: "—", searchPlaceholder: "Search wells", redrill: "Redrill" }, Ki = { title: "Filters", statusActive: "Active", statusCompleted: "Completed" }, Yi = { public: "Public", personal: "Personal", empty: "No groups yet", loading: "Loading…" }, Xi = { menu: "Actions", apply: "Apply", rename: "Edit", copyToPublic: "Copy to public", copyToPersonal: "Copy to personal", delete: "Delete", addFavorite: "Add to favorites", removeFavorite: "Remove from favorites" }, Zi = { name: "Name", namePlaceholder: "Enter a name", description: "Description", descriptionPlaceholder: "Enter a description", cancel: "Cancel", save: "Save" }, qi = { title: "Save", modeNew: "New group", modeExisting: "Existing group", personal: "Personal", public: "Public", group: "Group", groupPlaceholder: "Select a group" }, Ji = { title: "Edit group" }, Qi = { apply: "Apply", cancel: "Cancel", filter: "Filter", exportFilters: "Export filters", save: "Save" }, er = { collapse: "Collapse", expand: "Expand" }, tr = { close: "Close" }, nr = {
  Panel: Ui,
  Filters: Ki,
  Groups: Yi,
  GroupActions: Xi,
  GroupForm: Zi,
  SaveModal: qi,
  RenameModal: Ji,
  Footer: Qi,
  Tree: er,
  Header: tr
}, ir = { title: "Pozos de referencia", tabWells: "Pozos", tabGroups: "Grupos", primaryWell: "Pozo activo", plan: "Plan", fact: "Hecho", loading: "Cargando…", all: "Pozos de referencia", emptyNameFallback: "—", searchPlaceholder: "Buscar pozos", redrill: "Redrill" }, rr = { title: "Filtros", statusActive: "Activos", statusCompleted: "Finalizados" }, lr = { public: "Públicos", personal: "Personales", empty: "Aún no hay grupos", loading: "Cargando…" }, sr = { menu: "Acciones", apply: "Aplicar", rename: "Editar", copyToPublic: "Copiar a públicos", copyToPersonal: "Copiar a personales", delete: "Eliminar", addFavorite: "Añadir a favoritos", removeFavorite: "Quitar de favoritos" }, or = { name: "Nombre", namePlaceholder: "Introduzca un nombre", description: "Descripción", descriptionPlaceholder: "Introduzca una descripción", cancel: "Cancelar", save: "Guardar" }, ar = { title: "Guardar", modeNew: "Grupo nuevo", modeExisting: "Grupo existente", personal: "Personales", public: "Públicos", group: "Grupo", groupPlaceholder: "Seleccione un grupo" }, cr = { title: "Editar grupo" }, dr = { apply: "Aplicar", cancel: "Cancelar", filter: "Filtrar", exportFilters: "Exportar filtros", save: "Guardar" }, pr = { collapse: "Contraer", expand: "Expandir" }, ur = { close: "Cerrar" }, hr = {
  Panel: ir,
  Filters: rr,
  Groups: lr,
  GroupActions: sr,
  GroupForm: or,
  SaveModal: ar,
  RenameModal: cr,
  Footer: dr,
  Tree: pr,
  Header: ur
}, fr = { title: "Опорные скважины", tabWells: "Скважины", tabGroups: "Группы", primaryWell: "Активная скважина", plan: "План", fact: "Факт", loading: "Загрузка…", all: "Опорные скважины", emptyNameFallback: "—", searchPlaceholder: "Поиск скважин", redrill: "Перебур" }, mr = { title: "Фильтры", statusActive: "Активные", statusCompleted: "Законченные" }, br = { public: "Общие", personal: "Личные", empty: "Групп пока нет", loading: "Загрузка…" }, gr = { menu: "Действия", apply: "Применить", rename: "Редактировать", copyToPublic: "Копировать в общие", copyToPersonal: "Копировать в личные", delete: "Удалить", addFavorite: "В избранное", removeFavorite: "Убрать из избранного" }, yr = { name: "Название", namePlaceholder: "Введите название", description: "Описание", descriptionPlaceholder: "Введите описание", cancel: "Отмена", save: "Сохранить" }, Ir = { title: "Сохранить", modeNew: "Новая группа", modeExisting: "Существующая группа", personal: "Персональные", public: "Публичные", group: "Группа", groupPlaceholder: "Выберите группу" }, vr = { title: "Редактировать группу" }, Sr = { apply: "Применить", cancel: "Отменить", filter: "Отфильтровать", exportFilters: "Экспорт фильтров", save: "Сохранить" }, wr = { collapse: "Свернуть", expand: "Развернуть" }, _r = { close: "Закрыть" }, Wr = {
  Panel: fr,
  Filters: mr,
  Groups: br,
  GroupActions: gr,
  GroupForm: yr,
  SaveModal: Ir,
  RenameModal: vr,
  Footer: Sr,
  Tree: wr,
  Header: _r
}, We = "referenceWells";
function Tr(i) {
  const e = dn.createInstance();
  if (e.use(qt).init({
    resources: {
      en: { [We]: nr },
      ru: { [We]: Wr },
      es: { [We]: hr }
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: We,
    interpolation: {
      escapeValue: !1
    }
  }), i) {
    const t = e.t.bind(e);
    e.t = ((n, r) => {
      const l = Array.isArray(n) ? String(n[0]) : String(n);
      return e.exists(l) ? t(n, r) : i.exists(l) ? i.t(l, r) : t(n, r);
    });
  }
  return e;
}
function Cr({ language: i, parentI18n: e, children: t }) {
  const n = ke(() => Tr(e), [e]);
  return Me(() => {
    n.changeLanguage(i);
  }, [n, i]), /* @__PURE__ */ p(Jt, { i18n: n, children: t });
}
const Fr = "reference-wells-panel-module__panel__dv9xf", xr = "reference-wells-panel-module__panelEmbedded__qPp8D", kr = "reference-wells-panel-module__tabsBar__OWuZO", Pr = "reference-wells-panel-module__tabs__Wbb9b", Dr = "reference-wells-panel-module__sectionLabel__vZnmf", Er = "reference-wells-panel-module__previewTree__86tbs", Gr = "reference-wells-panel-module__treeArea__ZtlpD", Ar = "reference-wells-panel-module__scrollbar__g6FrG", jr = "reference-wells-panel-module__treeList__F5BGv", Nr = "reference-wells-panel-module__loadingPlaceholder__E5FUI", $ = {
  panel: Fr,
  panelEmbedded: xr,
  tabsBar: kr,
  tabs: Pr,
  sectionLabel: Dr,
  previewTree: Er,
  treeArea: Gr,
  scrollbar: Ar,
  treeList: jr,
  loadingPlaceholder: Nr
}, Mr = L(function({
  store: e,
  templatesStore: t,
  primaryWellName: n = null,
  showHeader: r = !0,
  onClose: l
}) {
  const { t: s } = j(), [o, a] = re("wells"), c = e.primaryWellId, u = e.primaryWell, d = e.wellTreeRows, h = e.isLoading, m = (n == null ? void 0 : n.trim()) || (u == null ? void 0 : u.name) || (T(c) ? String(c) : s("Panel.emptyNameFallback")), f = ke(
    () => [
      { value: "wells", label: s("Panel.tabWells") },
      { value: "groups", label: s("Panel.tabGroups") }
    ],
    [s]
  ), S = T(c) ? e.getWellChildren(c) : void 0, w = T(c) ? e.selectedTree.wells.find((E) => E.wellId === c) : void 0, v = e.lockPrimaryWellSubtree, M = T(c) ? Oe(e.selectedTree, c, S, e.visibility) : "unchecked", O = Be(w, S, e.visibility), ne = Le(w, S, e.visibility);
  return /* @__PURE__ */ F("aside", { className: D($.panel, !r && $.panelEmbedded), children: [
    r && /* @__PURE__ */ p(yi, { title: s("Panel.title"), onClose: l }),
    /* @__PURE__ */ p("div", { className: $.tabsBar, children: /* @__PURE__ */ p(Wt, { size: "s", value: o, items: f, onChange: a, className: $.tabs }) }),
    o === "wells" ? /* @__PURE__ */ F(q, { children: [
      /* @__PURE__ */ p("div", { className: D("dash-body-bold", $.sectionLabel), children: s("Panel.primaryWell") }),
      /* @__PURE__ */ p("div", { className: $.previewTree, children: T(c) ? /* @__PURE__ */ p(
        H,
        {
          label: m,
          checked: B(M),
          intermediate: J(M),
          disabled: !0,
          expandable: !v && e.wellHasVisibleChildren(c),
          expanded: !v && e.primaryExpanded,
          onExpandToggle: v ? void 0 : e.togglePrimaryExpanded,
          icon: u ? /* @__PURE__ */ p(Je, { status: u.status }) : void 0,
          children: !v && /* @__PURE__ */ p(
            ot,
            {
              store: e,
              wellId: c,
              planCheckState: O,
              factCheckState: ne
            }
          )
        }
      ) : /* @__PURE__ */ p("span", { className: D("dash-body-regular", $.loadingPlaceholder), children: s("Panel.emptyNameFallback") }) }),
      /* @__PURE__ */ p(Gn, { store: e }),
      /* @__PURE__ */ p(wi, { store: e }),
      /* @__PURE__ */ p("div", { className: $.treeArea, children: /* @__PURE__ */ p(Yt, { className: $.scrollbar, children: /* @__PURE__ */ p("div", { className: $.treeList, children: h && d.length === 0 ? /* @__PURE__ */ p("span", { className: D("dash-body-regular", $.loadingPlaceholder), children: s("Panel.loading") }) : /* @__PURE__ */ p(
        H,
        {
          label: s("Panel.all"),
          bold: !0,
          checked: e.allChecked,
          intermediate: e.allIntermediate,
          expanded: e.rootExpanded,
          expandable: d.length > 0,
          onCheckedChange: e.setAllChecked,
          onExpandToggle: e.toggleRootExpanded,
          children: d.map((E) => /* @__PURE__ */ p(
            H,
            {
              label: E.well.name,
              checked: B(E.checkState),
              intermediate: J(E.checkState),
              expandable: E.hasVisibleChildren,
              expanded: E.expanded,
              onCheckedChange: (ae) => e.setWellChecked(E.well.id, ae),
              onExpandToggle: () => e.toggleWellExpanded(E.well.id),
              icon: /* @__PURE__ */ p(Je, { status: E.well.status }),
              children: /* @__PURE__ */ p(
                ot,
                {
                  store: e,
                  wellId: E.well.id,
                  planCheckState: E.planCheckState,
                  factCheckState: E.factCheckState
                }
              )
            },
            E.well.id
          ))
        }
      ) }) }) }),
      /* @__PURE__ */ p(hi, { store: e, templatesStore: t })
    ] }) : /* @__PURE__ */ p(ni, { templatesStore: t })
  ] });
});
function ul({ language: i, parentI18n: e, ...t }) {
  return /* @__PURE__ */ p(Cr, { language: i, parentI18n: e, children: /* @__PURE__ */ p(Mr, { ...t }) });
}
var Rr = Object.defineProperty, Lr = Object.getOwnPropertyDescriptor, G = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? Lr(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && Rr(e, t, r), r;
};
function Br(i) {
  return {
    ...te,
    ...i
  };
}
class A {
  constructor(e) {
    I(this, "wellsSource");
    I(this, "onSelectionChange");
    I(this, "disposed", !1);
    I(this, "_primaryWellId");
    I(this, "_selectedTree");
    I(this, "_visibility");
    I(this, "_wellChildrenByWellId", /* @__PURE__ */ new Map());
    I(this, "_forcedPrimarySelection", null);
    I(this, "_lockPrimaryWellSubtree");
    var t, n, r;
    this.wellsSource = e.wellsSource, this.onSelectionChange = (t = e.onSelectionChange) != null ? t : null, this._primaryWellId = (n = e.primaryWellId) != null ? n : null, this._visibility = Br(e.visibility), this._lockPrimaryWellSubtree = (r = e.lockPrimaryWellSubtree) != null ? r : !1, this._selectedTree = Ie(), Se(this), e.initialSelectedTree && this.setSelectedTree(e.initialSelectedTree);
  }
  get wellsSourceRef() {
    return this.wellsSource;
  }
  get primaryWellId() {
    return this._primaryWellId;
  }
  get selectedTree() {
    return this._selectedTree;
  }
  /**
   * Explicit selected ids only (no whole-branch `[]` shorthand).
   * Use for widget consumers; omit unselected fact/plan branches.
   */
  getSelectedTreeForConsumers() {
    return wn(
      this._selectedTree,
      (e) => this._wellChildrenByWellId.get(e),
      this._visibility
    );
  }
  get visibility() {
    return this._visibility;
  }
  get lockPrimaryWellSubtree() {
    return this._lockPrimaryWellSubtree;
  }
  get forcedPrimarySelection() {
    return this._forcedPrimarySelection;
  }
  get wellChildrenByWellId() {
    return this._wellChildrenByWellId;
  }
  getWellChildren(e) {
    return this._wellChildrenByWellId.get(e);
  }
  setOnSelectionChange(e) {
    this.onSelectionChange = e;
  }
  setPrimaryWellId(e) {
    this._primaryWellId = e;
  }
  setAllWellChildren(e) {
    this._wellChildrenByWellId = new Map(e), this.setSelectedTree(this._selectedTree);
  }
  setForcedPrimarySelection(e) {
    this.assertAlive();
    const t = this._forcedPrimarySelection;
    if (Nt(t, e))
      return;
    const n = Ke(
      this._selectedTree,
      t,
      e,
      (r) => this._wellChildrenByWellId.get(r)
    );
    this._forcedPrimarySelection = Gi(e), this.setSelectedTree(n);
  }
  setSelectedTree(e) {
    this.assertAlive();
    const t = (l) => this._wellChildrenByWellId.get(l), n = Ni(e, this._forcedPrimarySelection, t), r = Gt(n, t, this._visibility);
    this._selectedTree = N(r), this.notifySelectionChange();
  }
  dispose() {
    this.disposed || (this.disposed = !0, this.onSelectionChange = null, this._selectedTree = Ie(), this._primaryWellId = null, this._wellChildrenByWellId = /* @__PURE__ */ new Map(), this._forcedPrimarySelection = null);
  }
  notifySelectionChange() {
    var e;
    (e = this.onSelectionChange) == null || e.call(this, this.getSelectedTreeForConsumers());
  }
  assertAlive() {
    if (this.disposed)
      throw new Error("ReferenceWellsService is disposed");
  }
}
G([
  W.ref
], A.prototype, "_primaryWellId", 2);
G([
  W.ref
], A.prototype, "_selectedTree", 2);
G([
  W.ref
], A.prototype, "_visibility", 2);
G([
  W.ref
], A.prototype, "_wellChildrenByWellId", 2);
G([
  W.ref
], A.prototype, "_forcedPrimarySelection", 2);
G([
  _
], A.prototype, "primaryWellId", 1);
G([
  _
], A.prototype, "selectedTree", 1);
G([
  _
], A.prototype, "visibility", 1);
G([
  _
], A.prototype, "forcedPrimarySelection", 1);
G([
  _
], A.prototype, "wellChildrenByWellId", 1);
G([
  y.bound
], A.prototype, "setOnSelectionChange", 1);
G([
  y.bound
], A.prototype, "setPrimaryWellId", 1);
G([
  y.bound
], A.prototype, "setAllWellChildren", 1);
G([
  y.bound
], A.prototype, "setForcedPrimarySelection", 1);
G([
  y.bound
], A.prototype, "setSelectedTree", 1);
G([
  y.bound
], A.prototype, "dispose", 1);
function Z(i, e) {
  return e.length === 0 ? !0 : i == null ? !1 : e.includes(i);
}
function at(i, e) {
  var t, n, r, l, s, o, a, c, u, d;
  if (!e || he(e))
    return !0;
  if (e.status.length > 0) {
    const h = i.status.toLowerCase();
    if (!e.status.some((f) => h.includes(f.toString().toLowerCase())))
      return !1;
  }
  return !(!Z((r = (t = i.block) == null ? void 0 : t.organizationId) != null ? r : (n = i.organization) == null ? void 0 : n.id, e.organizationId) || !Z((l = i.block) == null ? void 0 : l.id, e.blockId) || !Z((s = i.field) == null ? void 0 : s.id, e.fieldId) || !Z((a = i.padId) != null ? a : (o = i.pad) == null ? void 0 : o.id, e.padId) || !Z(i.id, e.wellId) || !Z((c = i.rigModel) == null ? void 0 : c.id, e.rigModelId) || !Z((d = i.brigadeId) != null ? d : (u = i.brigade) == null ? void 0 : u.id, e.brigadeId));
}
function Te(i, e) {
  return !e || e.wellboreTypeInstanceId.length === 0 ? !0 : Z(i.typeInstanceId, e.wellboreTypeInstanceId);
}
function ct(i, e) {
  return e ? {
    wellbore: i,
    trajectories: [...i.trajectories]
  } : {
    wellbore: i,
    trajectories: []
  };
}
function dt(i, e, t) {
  return i.filter((n) => t != null && n.id === t ? !0 : Te(n, e != null ? e : null));
}
function Or(i, e, t = null, n = null) {
  const r = (() => {
    var c;
    return e.showFact ? e.showWellbores ? dt((c = i == null ? void 0 : i.factWellbores) != null ? c : [], t, n).map(
      (u) => ct(u, e.showTrajectories)
    ) : [] : null;
  })(), l = (() => {
    var c;
    return e.showPlan ? ((c = i == null ? void 0 : i.planDesigns) != null ? c : []).map((u) => ({
      design: u,
      wellbores: e.showWellbores ? dt(u.wellbores, t, n).map(
        (d) => ct(d, e.showTrajectories)
      ) : []
    })) : null;
  })(), s = e.showFact && e.showPlan;
  return { fact: r, plan: l, showFactGroup: s && r !== null, showPlanGroup: s && l !== null };
}
function pt(i) {
  return !!(i.showFactGroup || i.showPlanGroup || i.fact !== null && i.fact.length > 0 || i.plan !== null && i.plan.length > 0);
}
const se = 1, ut = 0.5, ht = 0.2, xe = 0.1, Vr = 0.03, $r = 0.02, zr = 0.01;
function ft(i) {
  return i === "ACTIVE_GREEN" || i === "ACTIVE_YELLOW";
}
function mt(i) {
  return i < 0 ? -1 : i > 0 ? 1 : 0;
}
function Ye(i, e) {
  return i.localeCompare(e, void 0, { sensitivity: "base" }) * zr;
}
function Hr(i, e) {
  const t = le(i.checkState) ? se : 0, n = le(e.checkState) ? se : 0, r = ft(i.status) ? ut : 0, l = ft(e.status) ? ut : 0;
  return n - t + (l - r) + Ye(i.name, e.name);
}
function bt(i, e) {
  const t = le(i.checkState) ? se : 0, n = le(e.checkState) ? se : 0, r = i.isActive ? xe : 0, l = e.isActive ? xe : 0;
  return n - t + (l - r) + Ye(i.name, e.name);
}
function gt(i, e) {
  var u, d;
  const t = le(i.checkState) ? se : 0, n = le(e.checkState) ? se : 0, r = i.typeSlug.toLowerCase() === "main" ? ht : 0, l = e.typeSlug.toLowerCase() === "main" ? ht : 0, s = i.isActive ? xe : 0, o = e.isActive ? xe : 0, a = mt(i.typeIndex - e.typeIndex) * Vr, c = mt(((u = i.redrillingIndex) != null ? u : 0) - ((d = e.redrillingIndex) != null ? d : 0)) * $r;
  return n - t + (l - r) + (o - s) + a + c + Ye(i.name, e.name);
}
var Ur = Object.defineProperty, Kr = Object.getOwnPropertyDescriptor, b = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? Kr(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && Ur(e, t, r), r;
};
function pe(i) {
  return structuredClone(i);
}
class g {
  constructor(e, t) {
    I(this, "service");
    I(this, "filtersHostBridge");
    I(this, "_draftTree");
    I(this, "_filters");
    I(this, "expandedWellIds");
    I(this, "expandedFactWellIds");
    I(this, "expandedPlanWellIds");
    I(this, "expandedDesignKeys");
    I(this, "expandedWellboreKeys");
    I(this, "rootExpanded", !0);
    I(this, "primaryExpanded", !0);
    I(this, "searchValue", "");
    var n, r;
    this.service = e, this.filtersHostBridge = (n = t == null ? void 0 : t.filtersHostBridge) != null ? n : null, this._filters = ue((r = t == null ? void 0 : t.initialFilters) != null ? r : null), this._draftTree = N(e.selectedTree), this.expandedWellIds = W.set(), this.expandedFactWellIds = W.set(), this.expandedPlanWellIds = W.set(), this.expandedDesignKeys = W.set(), this.expandedWellboreKeys = W.set(), Se(this), this._filters && !he(this._filters) && this.commitPrunedSelection(this._draftTree);
  }
  setFiltersHostBridge(e) {
    this.filtersHostBridge = e;
  }
  get filters() {
    return this._filters;
  }
  get wellsSourceAllWells() {
    return this.service.wellsSourceRef.allWells;
  }
  get hasFiltersHost() {
    var e, t;
    return (t = (e = this.filtersHostBridge) == null ? void 0 : e.hasFiltersWidget) != null ? t : !1;
  }
  /** Versioned settings snapshot for gostorage (tree + filters). */
  getSettingsSnapshot() {
    return fe(this.service.selectedTree, this._filters);
  }
  get primaryWellId() {
    return this.service.primaryWellId;
  }
  get visibility() {
    return this.service.visibility;
  }
  get lockPrimaryWellSubtree() {
    return this.service.lockPrimaryWellSubtree;
  }
  get forcedPrimarySelection() {
    return this.service.forcedPrimarySelection;
  }
  isPrimarySubtreeLocked(e) {
    return this.lockPrimaryWellSubtree && e === this.primaryWellId;
  }
  isWellboreForced(e, t, n, r) {
    return ve(this.forcedPrimarySelection, e, t, n, r);
  }
  isTrajectoryForced(e, t, n, r, l) {
    return $e(this.forcedPrimarySelection, e, t, n, r, l);
  }
  isFactBranchForced(e) {
    return Mt(this.forcedPrimarySelection, e);
  }
  isPlanBranchForced(e) {
    return ze(this.forcedPrimarySelection, e);
  }
  isDesignForced(e, t) {
    return Rt(this.forcedPrimarySelection, e, t);
  }
  setForcedPrimarySelection(e) {
    const t = this.service.forcedPrimarySelection;
    this.service.setForcedPrimarySelection(e);
    const n = Ke(
      this._draftTree,
      t,
      this.service.forcedPrimarySelection,
      (r) => this.service.getWellChildren(r)
    );
    this.setDraftTree(n);
  }
  get isLoading() {
    return this.service.wellsSourceRef.isLoading;
  }
  get selectedTree() {
    return this._draftTree;
  }
  get appliedTree() {
    return this.service.selectedTree;
  }
  get hasPendingSelectionChanges() {
    return !Zt(this._draftTree, this.service.selectedTree);
  }
  get catalogWells() {
    const e = this.service.primaryWellId, t = this.searchValue.trim().toLowerCase(), n = this._filters;
    return this.service.wellsSourceRef.allWells.filter((r) => r.id === e || !at(r, n) ? !1 : t ? r.name.toLowerCase().includes(t) : !0);
  }
  get primaryWell() {
    var t;
    const e = this.service.primaryWellId;
    return T(e) && (t = this.service.wellsSourceRef.allWells.find((n) => n.id === e)) != null ? t : null;
  }
  get allCheckState() {
    return bn(
      this.selectedTree,
      this.catalogWells.map((e) => e.id),
      (e) => this.service.getWellChildren(e),
      this.visibility
    );
  }
  get allChecked() {
    return B(this.allCheckState);
  }
  get allIntermediate() {
    return J(this.allCheckState);
  }
  get wellTreeRows() {
    const e = this.selectedTree, t = this.visibility;
    return this.catalogWells.map((n) => {
      const r = this.service.getWellChildren(n.id), l = e.wells.find((o) => o.wellId === n.id), s = Oe(e, n.id, r, t);
      return {
        well: n,
        checkState: s,
        planCheckState: Be(l, r, t),
        factCheckState: Le(l, r, t),
        expanded: this.expandedWellIds.has(n.id),
        children: r,
        hasVisibleChildren: pt(this.buildProjectedWellBranch(n.id, r))
      };
    }).sort(
      (n, r) => Hr(
        { checkState: n.checkState, name: n.well.name, status: n.well.status },
        { checkState: r.checkState, name: r.well.name, status: r.well.status }
      )
    );
  }
  getWellChildren(e) {
    return this.service.getWellChildren(e);
  }
  getForcedWellboreIdForWell(e) {
    const t = this.service.forcedPrimarySelection;
    return !t || t.wellId !== e ? null : t.wellboreId;
  }
  buildProjectedWellBranch(e, t = this.getWellChildren(e)) {
    return Or(t, this.visibility, this._filters, this.getForcedWellboreIdForWell(e));
  }
  wellHasVisibleChildren(e) {
    return pt(this.buildProjectedWellBranch(e));
  }
  /**
   * UI projection for one well: which Fact/Plan/wellbore/traj nodes to render under visibility,
   * with checkbox state and tree sort order. Does not mutate catalog or selection.
   */
  getVisibleWellBranch(e) {
    const t = this.buildProjectedWellBranch(e), n = t.fact === null ? null : new Set(t.fact.map((o) => o.wellbore.id)), r = t.fact === null ? null : new Map(t.fact.map((o) => [o.wellbore.id, new Set(o.trajectories.map((a) => a.id))])), l = n === null ? null : this.getSortedFactWellbores(e).filter((o) => n.has(o.wellbore.id)).map(({ wellbore: o, checkState: a }) => {
      const c = r == null ? void 0 : r.get(o.id);
      return {
        wellbore: o,
        checkState: a,
        trajectories: this.getSortedTrajectories(e, o.id, "fact").filter(
          (u) => c == null ? void 0 : c.has(u.trajectory.id)
        )
      };
    }), s = t.plan === null ? null : this.getSortedPlanDesigns(e).map(({ design: o, checkState: a }) => {
      var h, m;
      const c = t.plan.find((f) => f.design.id === o.id), u = new Set((h = c == null ? void 0 : c.wellbores.map((f) => f.wellbore.id)) != null ? h : []), d = new Map(
        ((m = c == null ? void 0 : c.wellbores) != null ? m : []).map((f) => [
          f.wellbore.id,
          new Set(f.trajectories.map((S) => S.id))
        ])
      );
      return {
        design: o,
        checkState: a,
        wellbores: this.getSortedDesignWellbores(e, o.id).filter((f) => u.has(f.wellbore.id)).map(({ wellbore: f, checkState: S }) => {
          const w = d.get(f.id);
          return {
            wellbore: f,
            checkState: S,
            trajectories: this.getSortedTrajectories(e, f.id, "plan", o.id).filter(
              (v) => w == null ? void 0 : w.has(v.trajectory.id)
            )
          };
        })
      };
    });
    return {
      fact: l,
      plan: s,
      showFactGroup: t.showFactGroup,
      showPlanGroup: t.showPlanGroup
    };
  }
  isFactExpanded(e) {
    return this.expandedFactWellIds.has(e);
  }
  isPlanExpanded(e) {
    return this.expandedPlanWellIds.has(e);
  }
  isDesignExpanded(e, t) {
    return this.expandedDesignKeys.has(`${e}:design:${t}`);
  }
  isWellboreExpanded(e, t, n, r) {
    const l = t === "plan" && T(r) ? `${e}:plan:${r}:wb:${n}` : `${e}:fact:wb:${n}`;
    return this.expandedWellboreKeys.has(l);
  }
  getSortedFactWellbores(e) {
    const t = this.service.getWellChildren(e), n = this.selectedTree.wells.find((o) => o.wellId === e), r = this.visibility, l = (n == null ? void 0 : n.fact) !== void 0 && n.fact.length === 0;
    if (!t)
      return [];
    const s = this.getForcedWellboreIdForWell(e);
    return t.factWellbores.filter(
      (o) => s != null && o.id === s || Te(o, this._filters)
    ).map((o) => {
      const a = l ? "checked" : ye(
        n == null ? void 0 : n.fact,
        o.id,
        o.trajectories.map((c) => c.id),
        r.showTrajectories
      );
      return { wellbore: o, checkState: a };
    }).sort(
      (o, a) => gt(
        {
          checkState: o.checkState,
          name: o.wellbore.name,
          isActive: o.wellbore.isActive,
          typeSlug: o.wellbore.typeSlug,
          typeIndex: o.wellbore.typeIndex,
          redrillingIndex: o.wellbore.redrillingIndex
        },
        {
          checkState: a.checkState,
          name: a.wellbore.name,
          isActive: a.wellbore.isActive,
          typeSlug: a.wellbore.typeSlug,
          typeIndex: a.wellbore.typeIndex,
          redrillingIndex: a.wellbore.redrillingIndex
        }
      )
    );
  }
  getSortedPlanDesigns(e) {
    const t = this.service.getWellChildren(e), n = this.selectedTree.wells.find((s) => s.wellId === e), r = this.visibility, l = (n == null ? void 0 : n.plan) !== void 0 && n.plan.length === 0;
    return t ? t.planDesigns.map((s) => ({
      design: s,
      checkState: l ? "checked" : Re(
        n == null ? void 0 : n.plan,
        s.id,
        s.wellbores,
        r.showTrajectories,
        r.showWellbores
      )
    })).sort(
      (s, o) => bt(
        { checkState: s.checkState, name: s.design.name, isActive: s.design.isActive },
        { checkState: o.checkState, name: o.design.name, isActive: o.design.isActive }
      )
    ) : [];
  }
  getSortedDesignWellbores(e, t) {
    var u;
    const n = this.service.getWellChildren(e), r = this.selectedTree.wells.find((d) => d.wellId === e), l = n == null ? void 0 : n.planDesigns.find((d) => d.id === t), s = (u = r == null ? void 0 : r.plan) == null ? void 0 : u.find((d) => d.designId === t), o = this.visibility;
    if (!l)
      return [];
    const a = (r == null ? void 0 : r.plan) !== void 0 && r.plan.length === 0 || s == null ? void 0 : s.wellbores, c = this.getForcedWellboreIdForWell(e);
    return l.wellbores.filter(
      (d) => c != null && d.id === c || Te(d, this._filters)
    ).map((d) => {
      const h = (r == null ? void 0 : r.plan) !== void 0 && r.plan.length === 0, m = s !== void 0 && s.wellbores.length === 0;
      let f;
      return h || m ? f = "checked" : f = ye(
        a,
        d.id,
        d.trajectories.map((S) => S.id),
        o.showTrajectories
      ), { wellbore: d, checkState: f };
    }).sort(
      (d, h) => gt(
        {
          checkState: d.checkState,
          name: d.wellbore.name,
          isActive: d.wellbore.isActive,
          typeSlug: d.wellbore.typeSlug,
          typeIndex: d.wellbore.typeIndex,
          redrillingIndex: d.wellbore.redrillingIndex
        },
        {
          checkState: h.checkState,
          name: h.wellbore.name,
          isActive: h.wellbore.isActive,
          typeSlug: h.wellbore.typeSlug,
          typeIndex: h.wellbore.typeIndex,
          redrillingIndex: h.wellbore.redrillingIndex
        }
      )
    );
  }
  getSortedTrajectories(e, t, n, r) {
    var d;
    const l = this.service.getWellChildren(e), s = this.selectedTree.wells.find((h) => h.wellId === e);
    let o, a;
    if (n === "fact")
      o = l == null ? void 0 : l.factWellbores.find((h) => h.id === t), a = s == null ? void 0 : s.fact;
    else if (T(r)) {
      const h = l == null ? void 0 : l.planDesigns.find((w) => w.id === r);
      o = h == null ? void 0 : h.wellbores.find((w) => w.id === t);
      const m = (d = s == null ? void 0 : s.plan) == null ? void 0 : d.find((w) => w.designId === r), f = (s == null ? void 0 : s.plan) !== void 0 && s.plan.length === 0, S = m !== void 0 && m.wellbores.length === 0;
      f || S ? a = o ? [{ wellboreId: t, trajectories: [] }] : void 0 : a = m == null ? void 0 : m.wellbores;
    }
    if (!o)
      return [];
    const u = (s == null ? void 0 : s.fact) !== void 0 && s.fact.length === 0 ? [{ wellboreId: t, trajectories: [] }] : a;
    return o.trajectories.map((h) => ({
      trajectory: h,
      checkState: mn(u, t, h.id)
    })).sort(
      (h, m) => bt(
        {
          checkState: h.checkState,
          name: h.trajectory.name,
          isActive: h.trajectory.isActive
        },
        {
          checkState: m.checkState,
          name: m.trajectory.name,
          isActive: m.trajectory.isActive
        }
      )
    );
  }
  setSearchValue(e) {
    this.searchValue = e;
  }
  setAllWellChildren(e) {
    this.service.setAllWellChildren(e), this.setDraftTree(this._draftTree), this._filters && !he(this._filters) && this.commitPrunedSelection(this._draftTree);
  }
  syncDraftFromApplied() {
    this._draftTree = N(this.service.selectedTree);
  }
  applyDraftSelection() {
    this.commitPrunedSelection(this._draftTree);
  }
  applySettingsFromGroup(e) {
    this._filters = ue(e.filters), this._draftTree = N(e.tree), this.applyDraftSelection();
  }
  resetDraftSelection() {
    this._draftTree = N(this.service.selectedTree);
  }
  importFiltersFromHost() {
    var e;
    (e = this.filtersHostBridge) != null && e.hasFiltersWidget && (this._filters = ue(this.filtersHostBridge.pullFilters()), this.applyDraftSelection());
  }
  exportFiltersToHost() {
    var e;
    !((e = this.filtersHostBridge) != null && e.hasFiltersWidget) || this._filters === null || this.filtersHostBridge.pushFilters(ue(this._filters));
  }
  /** Prune by current filters and commit to service + draft. */
  commitPrunedSelection(e) {
    const t = this.pruneTreeByWellsFilters(e);
    this.service.setSelectedTree(t), this._draftTree = N(this.service.selectedTree);
  }
  /**
   * Drop non-primary wells that do not pass well filters, and prune wellbores
   * that do not pass wellboreTypeInstanceId (forced/primary wellbores kept).
   */
  pruneTreeByWellsFilters(e) {
    const t = this._filters;
    if (!t || he(t))
      return N(e);
    const n = new Map(this.service.wellsSourceRef.allWells.map((o) => [o.id, o])), r = this.service.primaryWellId, l = this.service.forcedPrimarySelection;
    return { wells: e.wells.filter((o) => {
      if (o.wellId === r)
        return !0;
      const a = n.get(o.wellId);
      return a ? at(a, t) : !1;
    }).map((o) => this.pruneWellSelectionByWellboreFilters(o, t, l)) };
  }
  pruneWellSelectionByWellboreFilters(e, t, n) {
    var o;
    if (t.wellboreTypeInstanceId.length === 0)
      return structuredClone(e);
    const r = this.service.getWellChildren(e.wellId), l = (a, c, u) => {
      var h;
      if (n && ve(n, e.wellId, c, a, u))
        return !0;
      const d = c === "fact" ? r == null ? void 0 : r.factWellbores.find((m) => m.id === a) : (h = r == null ? void 0 : r.planDesigns.find((m) => m.id === u)) == null ? void 0 : h.wellbores.find((m) => m.id === a);
      return d ? Te(d, t) : r == null;
    }, s = { wellId: e.wellId };
    if (e.fact !== void 0)
      if (e.fact.length === 0)
        if (!r)
          s.fact = [];
        else {
          const a = r.factWellbores.filter((c) => l(c.id, "fact")).map((c) => ({ wellboreId: c.id, trajectories: [] }));
          a.length === 0 || (a.length === r.factWellbores.length ? s.fact = [] : s.fact = a);
        }
      else {
        const a = e.fact.filter((c) => l(c.wellboreId, "fact"));
        a.length > 0 && (s.fact = a.map((c) => structuredClone(c)));
      }
    if (e.plan !== void 0)
      if (e.plan.length === 0)
        if (!r)
          s.plan = [];
        else {
          const a = r.planDesigns.map((c) => {
            const u = c.wellbores.filter((d) => l(d.id, "plan", c.id)).map((d) => ({ wellboreId: d.id, trajectories: [] }));
            return u.length === 0 ? null : u.length === c.wellbores.length ? { designId: c.id, wellbores: [] } : { designId: c.id, wellbores: u };
          }).filter((c) => c !== null);
          a.length > 0 && (s.plan = a.length === r.planDesigns.length && a.every((c) => c.wellbores.length === 0) ? [] : a);
        }
      else {
        const a = [];
        for (const c of e.plan)
          if (c.wellbores.length === 0) {
            const u = r == null ? void 0 : r.planDesigns.find((h) => h.id === c.designId), d = (o = u == null ? void 0 : u.wellbores.filter((h) => l(h.id, "plan", c.designId)).map((h) => ({ wellboreId: h.id, trajectories: [] }))) != null ? o : [];
            if (d.length === 0)
              continue;
            u && d.length === u.wellbores.length ? a.push({ designId: c.designId, wellbores: [] }) : a.push({ designId: c.designId, wellbores: d });
          } else {
            const u = c.wellbores.filter((d) => l(d.wellboreId, "plan", c.designId));
            u.length > 0 && a.push({
              designId: c.designId,
              wellbores: u.map((d) => structuredClone(d))
            });
          }
        a.length > 0 && (s.plan = a);
      }
    return s;
  }
  togglePrimaryExpanded() {
    this.primaryExpanded = !this.primaryExpanded;
  }
  toggleRootExpanded() {
    this.rootExpanded = !this.rootExpanded;
  }
  toggleWellExpanded(e) {
    this.expandedWellIds.has(e) ? this.expandedWellIds.delete(e) : this.expandedWellIds.add(e);
  }
  toggleFactExpanded(e) {
    this.expandedFactWellIds.has(e) ? this.expandedFactWellIds.delete(e) : this.expandedFactWellIds.add(e);
  }
  togglePlanExpanded(e) {
    this.expandedPlanWellIds.has(e) ? this.expandedPlanWellIds.delete(e) : this.expandedPlanWellIds.add(e);
  }
  toggleDesignExpanded(e, t) {
    const n = `${e}:design:${t}`;
    this.expandedDesignKeys.has(n) ? this.expandedDesignKeys.delete(n) : this.expandedDesignKeys.add(n);
  }
  toggleWellboreExpanded(e, t, n, r) {
    const l = t === "plan" && T(r) ? `${e}:plan:${r}:wb:${n}` : `${e}:fact:wb:${n}`;
    this.expandedWellboreKeys.has(l) ? this.expandedWellboreKeys.delete(l) : this.expandedWellboreKeys.add(l);
  }
  setAllChecked(e) {
    const t = this.service.primaryWellId, n = T(t) ? this.selectedTree.wells.find((o) => o.wellId === t) : void 0, r = n ? pe(n) : void 0;
    if (!e) {
      this.setDraftTree({ wells: r ? [r] : [] });
      return;
    }
    const l = this.visibility, s = this.catalogWells.map((o) => {
      const a = { wellId: o.id };
      return l.showFact && (a.fact = []), l.showPlan && (a.plan = []), a;
    });
    r && s.push(r), this.setDraftTree({ wells: s });
  }
  setWellChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.filter((r) => r.wellId !== e);
    if (t) {
      const r = { wellId: e }, l = this.visibility;
      l.showFact && (r.fact = []), l.showPlan && (r.plan = []), n.push(r);
    }
    this.setDraftTree({ wells: n });
  }
  setFactChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.map(pe);
    let r = n.find((l) => l.wellId === e);
    if (!r) {
      if (!t)
        return;
      r = { wellId: e }, n.push(r);
    }
    if (t)
      r.fact = [];
    else {
      delete r.fact;
      const l = this.forcedPrimarySelection;
      (l == null ? void 0 : l.wellId) === e && l.branch === "fact" && Object.assign(r, it(r, l, this.service.getWellChildren(e)));
    }
    this.commitWells(n);
  }
  setPlanChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.map(pe);
    let r = n.find((l) => l.wellId === e);
    if (!r) {
      if (!t)
        return;
      r = { wellId: e }, n.push(r);
    }
    if (t)
      r.plan = [];
    else {
      delete r.plan;
      const l = this.forcedPrimarySelection;
      (l == null ? void 0 : l.wellId) === e && l.branch === "plan" && Object.assign(r, it(r, l, this.service.getWellChildren(e)));
    }
    this.commitWells(n);
  }
  setFactWellboreChecked(e, t, n) {
    this.isPrimarySubtreeLocked(e) || !n && this.isWellboreForced(e, "fact", t) || this.updateFactWellbores(e, (r, l) => {
      const s = r.filter((o) => o.wellboreId !== t);
      return n ? (s.push({ wellboreId: t, trajectories: [] }), l && s.length === l.factWellbores.length && s.every((a) => a.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: s }) : s.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: s };
    });
  }
  setFactTrajectoryChecked(e, t, n, r) {
    this.isPrimarySubtreeLocked(e) || !r && this.isTrajectoryForced(e, "fact", t, n) || this.updateFactWellbores(e, (l, s) => {
      var m;
      const o = s == null ? void 0 : s.factWellbores.find((f) => f.id === t), a = (m = o == null ? void 0 : o.trajectories.map((f) => f.id)) != null ? m : [], c = l.find((f) => f.wellboreId === t), u = new Set(
        c ? c.trajectories.length === 0 ? a : c.trajectories.map((f) => f.trajectoryId) : []
      );
      r ? u.add(n) : u.delete(n);
      const d = l.filter((f) => f.wellboreId !== t);
      if (u.size === 0)
        return d.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: d };
      const h = a.length > 0 && u.size === a.length ? [] : Array.from(u).map((f) => ({ trajectoryId: f }));
      return d.push({ wellboreId: t, trajectories: h }), s && d.length === s.factWellbores.length && d.every((S) => S.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: d };
    });
  }
  setDesignChecked(e, t, n) {
    this.isPrimarySubtreeLocked(e) || this.updatePlanDesigns(e, (r, l) => {
      const s = r.filter((o) => o.designId !== t);
      if (!n) {
        const o = this.forcedPrimarySelection;
        return (o == null ? void 0 : o.wellId) === e && o.branch === "plan" && o.designId === t ? (s.push({
          designId: t,
          wellbores: [
            {
              wellboreId: o.wellboreId,
              trajectories: T(o.trajectoryId) ? [{ trajectoryId: o.trajectoryId }] : []
            }
          ]
        }), { kind: "partial", designs: s }) : s.length === 0 ? { kind: "none" } : { kind: "partial", designs: s };
      }
      return s.push({ designId: t, wellbores: [] }), l && s.length === l.planDesigns.length && s.every((a) => a.wellbores.length === 0) ? { kind: "whole" } : { kind: "partial", designs: s };
    });
  }
  setPlanWellboreChecked(e, t, n, r) {
    this.isPrimarySubtreeLocked(e) || !r && this.isWellboreForced(e, "plan", n, t) || this.updatePlanDesignWellbores(e, t, (l, s) => {
      const o = l.filter((a) => a.wellboreId !== n);
      return r ? (o.push({ wellboreId: n, trajectories: [] }), s && o.length === s.wellbores.length && o.every((c) => c.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: o }) : o.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: o };
    });
  }
  setPlanTrajectoryChecked(e, t, n, r, l) {
    this.isPrimarySubtreeLocked(e) || !l && this.isTrajectoryForced(e, "plan", n, r, t) || this.updatePlanDesignWellbores(e, t, (s, o) => {
      var f;
      const a = o == null ? void 0 : o.wellbores.find((S) => S.id === n), c = (f = a == null ? void 0 : a.trajectories.map((S) => S.id)) != null ? f : [], u = s.find((S) => S.wellboreId === n), d = new Set(
        u ? u.trajectories.length === 0 ? c : u.trajectories.map((S) => S.trajectoryId) : []
      );
      l ? d.add(r) : d.delete(r);
      const h = s.filter((S) => S.wellboreId !== n);
      if (d.size === 0)
        return h.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: h };
      const m = c.length > 0 && d.size === c.length ? [] : Array.from(d).map((S) => ({ trajectoryId: S }));
      return h.push({ wellboreId: n, trajectories: m }), o && h.length === o.wellbores.length && h.every((w) => w.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: h };
    });
  }
  updateFactWellbores(e, t) {
    var a;
    const n = this.selectedTree.wells.map(pe);
    let r = n.find((c) => c.wellId === e);
    const l = this.service.getWellChildren(e);
    r || (r = { wellId: e }, n.push(r));
    const s = r.fact === void 0 ? [] : r.fact.length === 0 ? (a = l == null ? void 0 : l.factWellbores.map((c) => ({ wellboreId: c.id, trajectories: [] }))) != null ? a : [] : r.fact, o = t(
      s.map((c) => structuredClone(c)),
      l
    );
    o.kind === "whole" ? r.fact = [] : o.kind === "none" ? delete r.fact : r.fact = o.wellbores, this.commitWells(n);
  }
  updatePlanDesigns(e, t) {
    var a;
    const n = this.selectedTree.wells.map(pe);
    let r = n.find((c) => c.wellId === e);
    const l = this.service.getWellChildren(e);
    r || (r = { wellId: e }, n.push(r));
    const s = r.plan === void 0 ? [] : r.plan.length === 0 ? (a = l == null ? void 0 : l.planDesigns.map((c) => ({
      designId: c.id,
      wellbores: []
    }))) != null ? a : [] : r.plan, o = t(
      s.map((c) => structuredClone(c)),
      l
    );
    o.kind === "whole" ? r.plan = [] : o.kind === "none" ? delete r.plan : r.plan = o.designs, this.commitWells(n);
  }
  updatePlanDesignWellbores(e, t, n) {
    this.updatePlanDesigns(e, (r, l) => {
      var d;
      const s = l == null ? void 0 : l.planDesigns.find((h) => h.id === t), o = r.find((h) => h.designId === t), a = o ? o.wellbores.length === 0 ? (d = s == null ? void 0 : s.wellbores.map((h) => ({ wellboreId: h.id, trajectories: [] }))) != null ? d : [] : o.wellbores : [], c = n(
        a.map((h) => structuredClone(h)),
        s
      ), u = r.filter((h) => h.designId !== t);
      return c.kind === "none" ? u.length === 0 ? { kind: "none" } : { kind: "partial", designs: u } : (c.kind === "whole" ? u.push({ designId: t, wellbores: [] }) : u.push({ designId: t, wellbores: c.wellbores }), l && u.length === l.planDesigns.length && u.every((m) => m.wellbores.length === 0) ? { kind: "whole" } : { kind: "partial", designs: u });
    });
  }
  commitWells(e) {
    const t = e.filter((n) => n.fact !== void 0 || n.plan !== void 0);
    this.setDraftTree({ wells: t });
  }
  setDraftTree(e) {
    const t = Gt(
      e,
      (n) => this.service.getWellChildren(n),
      this.visibility
    );
    this._draftTree = N(t);
  }
}
b([
  W.ref
], g.prototype, "_draftTree", 2);
b([
  W.ref
], g.prototype, "_filters", 2);
b([
  W
], g.prototype, "expandedWellIds", 2);
b([
  W
], g.prototype, "expandedFactWellIds", 2);
b([
  W
], g.prototype, "expandedPlanWellIds", 2);
b([
  W
], g.prototype, "expandedDesignKeys", 2);
b([
  W
], g.prototype, "expandedWellboreKeys", 2);
b([
  W
], g.prototype, "rootExpanded", 2);
b([
  W
], g.prototype, "primaryExpanded", 2);
b([
  W
], g.prototype, "searchValue", 2);
b([
  y.bound
], g.prototype, "setFiltersHostBridge", 1);
b([
  _
], g.prototype, "filters", 1);
b([
  _
], g.prototype, "wellsSourceAllWells", 1);
b([
  _
], g.prototype, "hasFiltersHost", 1);
b([
  _
], g.prototype, "primaryWellId", 1);
b([
  _
], g.prototype, "visibility", 1);
b([
  _
], g.prototype, "forcedPrimarySelection", 1);
b([
  y.bound
], g.prototype, "setForcedPrimarySelection", 1);
b([
  _
], g.prototype, "isLoading", 1);
b([
  _
], g.prototype, "selectedTree", 1);
b([
  _
], g.prototype, "appliedTree", 1);
b([
  _
], g.prototype, "hasPendingSelectionChanges", 1);
b([
  _
], g.prototype, "catalogWells", 1);
b([
  _
], g.prototype, "primaryWell", 1);
b([
  _
], g.prototype, "allCheckState", 1);
b([
  _
], g.prototype, "allChecked", 1);
b([
  _
], g.prototype, "allIntermediate", 1);
b([
  _
], g.prototype, "wellTreeRows", 1);
b([
  y.bound
], g.prototype, "setSearchValue", 1);
b([
  y.bound
], g.prototype, "setAllWellChildren", 1);
b([
  y.bound
], g.prototype, "syncDraftFromApplied", 1);
b([
  y.bound
], g.prototype, "applyDraftSelection", 1);
b([
  y.bound
], g.prototype, "applySettingsFromGroup", 1);
b([
  y.bound
], g.prototype, "resetDraftSelection", 1);
b([
  y.bound
], g.prototype, "importFiltersFromHost", 1);
b([
  y.bound
], g.prototype, "exportFiltersToHost", 1);
b([
  y.bound
], g.prototype, "togglePrimaryExpanded", 1);
b([
  y.bound
], g.prototype, "toggleRootExpanded", 1);
b([
  y.bound
], g.prototype, "toggleWellExpanded", 1);
b([
  y.bound
], g.prototype, "toggleFactExpanded", 1);
b([
  y.bound
], g.prototype, "togglePlanExpanded", 1);
b([
  y.bound
], g.prototype, "toggleDesignExpanded", 1);
b([
  y.bound
], g.prototype, "toggleWellboreExpanded", 1);
b([
  y.bound
], g.prototype, "setAllChecked", 1);
b([
  y.bound
], g.prototype, "setWellChecked", 1);
b([
  y.bound
], g.prototype, "setFactChecked", 1);
b([
  y.bound
], g.prototype, "setPlanChecked", 1);
b([
  y.bound
], g.prototype, "setFactWellboreChecked", 1);
b([
  y.bound
], g.prototype, "setFactTrajectoryChecked", 1);
b([
  y.bound
], g.prototype, "setDesignChecked", 1);
b([
  y.bound
], g.prototype, "setPlanWellboreChecked", 1);
b([
  y.bound
], g.prototype, "setPlanTrajectoryChecked", 1);
b([
  y
], g.prototype, "setDraftTree", 1);
var Yr = Object.defineProperty, Xr = Object.getOwnPropertyDescriptor, Pe = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? Xr(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && Yr(e, t, r), r;
};
class De {
  constructor(e) {
    I(this, "api");
    I(this, "referenceWellsStore");
    I(this, "isLoading", !1);
    I(this, "error", null);
    this.api = e.api, this.referenceWellsStore = e.referenceWellsStore, Se(this);
  }
  *load() {
    this.isLoading = !0, this.error = null;
    try {
      const e = yield this.api.fetchChildren();
      this.referenceWellsStore.setAllWellChildren(e);
    } catch (e) {
      console.error(e), this.error = e;
    } finally {
      this.isLoading = !1;
    }
  }
  dispose() {
    this.error = null, this.isLoading = !1;
  }
}
Pe([
  W
], De.prototype, "isLoading", 2);
Pe([
  W
], De.prototype, "error", 2);
Pe([
  U.bound
], De.prototype, "load", 1);
Pe([
  y.bound
], De.prototype, "dispose", 1);
const yt = 1, Zr = 0.1;
function qr(i, e) {
  const t = i.isFavorite ? yt : 0, n = e.isFavorite ? yt : 0, r = i.name.localeCompare(e.name, void 0, { sensitivity: "base" }) * Zr;
  return n - t + r;
}
var Jr = Object.defineProperty, Qr = Object.getOwnPropertyDescriptor, k = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? Qr(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && Jr(e, t, r), r;
};
function It() {
  return crypto.randomUUID();
}
function vt(i) {
  const e = me(i.tree);
  return {
    ...i,
    tree: fe(e.tree, e.filters)
  };
}
function St(i) {
  return i != null && i.data ? i.data.type === "public" ? {
    ...i,
    data: {
      ...i.data,
      templates: i.data.templates.map(vt)
    }
  } : i.data.type === "personal" ? {
    ...i,
    data: {
      ...i.data,
      templates: i.data.templates.map(vt)
    }
  } : i : i;
}
function je(i, e) {
  return {
    id: i.id,
    data: e,
    status: "ACTIVE",
    objectType: i.objectType
  };
}
class P {
  constructor(e) {
    I(this, "api");
    I(this, "wellsService");
    I(this, "getOwnerUserId");
    I(this, "getDraftTree");
    I(this, "getDraftFilters");
    I(this, "applyReferenceWellsSettings");
    I(this, "onCommittedSelection");
    I(this, "groupFavorites");
    I(this, "publicDoc", null);
    I(this, "personalDoc", null);
    I(this, "isLoading", !1);
    I(this, "isSaving", !1);
    I(this, "saveModalOpen", !1);
    I(this, "renameTarget", null);
    this.api = e.api, this.wellsService = e.wellsService, this.getOwnerUserId = e.getOwnerUserId, this.getDraftTree = e.getDraftTree, this.getDraftFilters = e.getDraftFilters, this.applyReferenceWellsSettings = e.applyReferenceWellsSettings, this.onCommittedSelection = e.onCommittedSelection, this.groupFavorites = e.groupFavorites, Se(this);
  }
  get publicGroups() {
    var t, n;
    const e = ((n = (t = this.publicDoc) == null ? void 0 : t.data) == null ? void 0 : n.type) === "public" ? this.publicDoc.data.templates : [];
    return this.mapAndSortGroups(e, "public");
  }
  get personalGroups() {
    var t, n;
    const e = ((n = (t = this.personalDoc) == null ? void 0 : t.data) == null ? void 0 : n.type) === "personal" ? this.personalDoc.data.templates : [];
    return this.mapAndSortGroups(e, "personal");
  }
  get lastAppliedTemplateId() {
    var e, t;
    return ((t = (e = this.personalDoc) == null ? void 0 : e.data) == null ? void 0 : t.type) !== "personal" ? null : this.personalDoc.data.lastAppliedTemplateId;
  }
  get hasAnyGroups() {
    return this.publicGroups.length > 0 || this.personalGroups.length > 0;
  }
  get canCreate() {
    return T(this.wellsService.primaryWellId) && !this.isLoading;
  }
  openSaveModal() {
    this.saveModalOpen = !0;
  }
  closeSaveModal() {
    this.saveModalOpen = !1;
  }
  openRenameModal(e) {
    this.renameTarget = e;
  }
  closeRenameModal() {
    this.renameTarget = null;
  }
  toggleGroupFavorite(e) {
    var t;
    (t = this.groupFavorites) == null || t.toggleFavorite(e);
  }
  isGroupFavorite(e) {
    var t, n;
    return (n = (t = this.groupFavorites) == null ? void 0 : t.isFavorite(e)) != null ? n : !1;
  }
  *loadTemplatesForWell(e) {
    var t, n;
    if (!T(e)) {
      this.publicDoc = null, this.personalDoc = null;
      return;
    }
    this.isLoading = !0;
    try {
      const r = this.getOwnerUserId(), [l, s] = yield Promise.all([this.api.listPublic(e), this.api.listPersonal(e, r)]);
      this.publicDoc = St((t = l[0]) != null ? t : null), this.personalDoc = St((n = s[0]) != null ? n : null);
    } catch (r) {
      console.error(r), this.publicDoc = null, this.personalDoc = null;
    } finally {
      this.isLoading = !1;
    }
  }
  *reloadForWellChange(e) {
    this.commitSelectedTree(Ie()), yield this.loadTemplatesForWell(e), this.restoreLastApplied();
  }
  *createGroupFromCurrentSelection(e, t, n = "") {
    yield this.createGroupWithTree(e, t, this.getSelectionTreeForSave(), n);
  }
  *createGroupWithTree(e, t, n, r = "") {
    const l = this.wellsService.primaryWellId;
    if (!T(l))
      return;
    const s = e.trim();
    if (s) {
      this.isSaving = !0;
      try {
        const o = r.trim(), a = {
          id: It(),
          name: s,
          ...o ? { description: o } : {},
          tree: fe(n, this.getFiltersForSave())
        };
        t === "public" ? yield this.appendTemplateToPublic(l, a) : yield this.appendTemplateToPersonal(l, a), this.saveModalOpen = !1;
      } catch (o) {
        console.error(o);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *renameGroup(e, t, n, r = "") {
    const l = n.trim();
    if (l) {
      this.isSaving = !0;
      try {
        const s = r.trim();
        yield this.updateTemplateFields(e, t, (o) => {
          const a = {
            ...o,
            name: l
          };
          return s ? a.description = s : delete a.description, a;
        }), this.renameTarget = null;
      } catch (s) {
        console.error(s);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *updateGroupWithCurrentTree(e, t) {
    this.isSaving = !0;
    try {
      const n = fe(this.getSelectionTreeForSave(), this.getFiltersForSave());
      yield this.updateTemplateFields(e, t, (r) => ({
        ...r,
        tree: n
      })), this.saveModalOpen = !1;
    } catch (n) {
      console.error(n);
    } finally {
      this.isSaving = !1;
    }
  }
  *applyGroup(e, t) {
    const n = this.findTemplate(e, t);
    if (n) {
      this.isSaving = !0;
      try {
        this.commitGroupSettings(me(n.tree)), yield this.setLastAppliedTemplateId(e);
      } catch (r) {
        console.error(r);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *duplicateGroup(e, t) {
    const n = this.findTemplate(e, t), r = this.wellsService.primaryWellId;
    if (!(!n || !T(r))) {
      this.isSaving = !0;
      try {
        const l = me(n.tree), s = {
          id: It(),
          name: n.name,
          ...n.description ? { description: n.description } : {},
          tree: fe(l.tree, l.filters)
        };
        (t === "public" ? "personal" : "public") === "public" ? yield this.appendTemplateToPublic(r, s) : yield this.appendTemplateToPersonal(r, s);
      } catch (l) {
        console.error(l);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *deleteGroup(e, t) {
    this.isSaving = !0;
    try {
      if (t === "public") {
        const s = this.publicDoc;
        if (!s || s.data.type !== "public")
          return;
        const o = s.data.templates.filter((c) => c.id !== e), a = {
          ...s.data,
          templates: o
        };
        o.length === 0 ? (yield this.api.delete(s.id), this.publicDoc = null) : (yield this.api.update(s.id, a), this.publicDoc = { ...s, data: a });
        return;
      }
      const n = this.personalDoc;
      if (!n || n.data.type !== "personal")
        return;
      const r = n.data.templates.filter((s) => s.id !== e), l = {
        ...n.data,
        templates: r,
        lastAppliedTemplateId: n.data.lastAppliedTemplateId === e ? null : n.data.lastAppliedTemplateId
      };
      r.length === 0 && !T(l.lastAppliedTemplateId) ? (yield this.api.delete(n.id), this.personalDoc = null) : (yield this.api.update(n.id, l), this.personalDoc = { ...n, data: l });
    } catch (n) {
      console.error(n);
    } finally {
      this.isSaving = !1;
    }
  }
  restoreLastApplied() {
    var n, r, l;
    if (((r = (n = this.personalDoc) == null ? void 0 : n.data) == null ? void 0 : r.type) !== "personal")
      return;
    const e = this.personalDoc.data.lastAppliedTemplateId;
    if (!T(e))
      return;
    const t = (l = this.findTemplate(e, "personal")) != null ? l : this.findTemplate(e, "public");
    t && this.commitGroupSettings(me(t.tree));
  }
  mapAndSortGroups(e, t) {
    var n;
    return (n = this.groupFavorites) == null || n.favoriteIds, e.map((r) => {
      var l, s;
      return {
        id: r.id,
        name: r.name,
        description: r.description,
        visibility: t,
        isFavorite: (s = (l = this.groupFavorites) == null ? void 0 : l.isFavorite(r.id)) != null ? s : !1
      };
    }).sort(qr);
  }
  getSelectionTreeForSave() {
    var e, t;
    return (t = (e = this.getDraftTree) == null ? void 0 : e.call(this)) != null ? t : this.wellsService.selectedTree;
  }
  getFiltersForSave() {
    var e, t;
    return (t = (e = this.getDraftFilters) == null ? void 0 : e.call(this)) != null ? t : null;
  }
  /** Apply group envelope to RW (tree + filters). Falls back to tree-only commit. */
  commitGroupSettings(e) {
    var t;
    if (this.applyReferenceWellsSettings) {
      this.applyReferenceWellsSettings(e);
      return;
    }
    this.wellsService.setSelectedTree(e.tree), (t = this.onCommittedSelection) == null || t.call(this);
  }
  commitSelectedTree(e) {
    var t;
    this.wellsService.setSelectedTree(e), (t = this.onCommittedSelection) == null || t.call(this);
  }
  findTemplate(e, t) {
    var n, r, l, s;
    if (t === "public")
      return ((r = (n = this.publicDoc) == null ? void 0 : n.data) == null ? void 0 : r.type) !== "public" ? void 0 : this.publicDoc.data.templates.find((o) => o.id === e);
    if (((s = (l = this.personalDoc) == null ? void 0 : l.data) == null ? void 0 : s.type) === "personal")
      return this.personalDoc.data.templates.find((o) => o.id === e);
  }
  async appendTemplateToPublic(e, t) {
    const n = this.publicDoc;
    if (n && n.data.type === "public") {
      const s = {
        ...n.data,
        templates: [...n.data.templates, t]
      };
      await this.api.update(n.id, s), K(() => {
        this.publicDoc = { ...n, data: s };
      });
      return;
    }
    const r = {
      type: "public",
      wellId: e,
      templates: [t]
    }, l = await this.api.create(r);
    K(() => {
      this.publicDoc = je(l, r);
    });
  }
  async appendTemplateToPersonal(e, t) {
    const n = this.personalDoc, r = this.getOwnerUserId();
    if (n && n.data.type === "personal") {
      const o = {
        ...n.data,
        templates: [...n.data.templates, t]
      };
      await this.api.update(n.id, o), K(() => {
        this.personalDoc = { ...n, data: o };
      });
      return;
    }
    const l = {
      type: "personal",
      ownerUserId: r,
      wellId: e,
      lastAppliedTemplateId: null,
      templates: [t]
    }, s = await this.api.create(l);
    K(() => {
      this.personalDoc = je(s, l);
    });
  }
  async updateTemplateFields(e, t, n) {
    if (t === "public") {
      const s = this.publicDoc;
      if (!s || s.data.type !== "public")
        return;
      const o = {
        ...s.data,
        templates: s.data.templates.map((a) => a.id === e ? n(a) : a)
      };
      await this.api.update(s.id, o), K(() => {
        this.publicDoc = { ...s, data: o };
      });
      return;
    }
    const r = this.personalDoc;
    if (!r || r.data.type !== "personal")
      return;
    const l = {
      ...r.data,
      templates: r.data.templates.map((s) => s.id === e ? n(s) : s)
    };
    await this.api.update(r.id, l), K(() => {
      this.personalDoc = { ...r, data: l };
    });
  }
  async setLastAppliedTemplateId(e) {
    const t = this.wellsService.primaryWellId;
    if (!T(t))
      return;
    const n = this.personalDoc, r = this.getOwnerUserId();
    if (n && n.data.type === "personal") {
      const o = {
        ...n.data,
        lastAppliedTemplateId: e
      };
      await this.api.update(n.id, o), K(() => {
        this.personalDoc = { ...n, data: o };
      });
      return;
    }
    const l = {
      type: "personal",
      ownerUserId: r,
      wellId: t,
      lastAppliedTemplateId: e,
      templates: []
    }, s = await this.api.create(l);
    K(() => {
      this.personalDoc = je(s, l);
    });
  }
}
k([
  W.ref
], P.prototype, "publicDoc", 2);
k([
  W.ref
], P.prototype, "personalDoc", 2);
k([
  W
], P.prototype, "isLoading", 2);
k([
  W
], P.prototype, "isSaving", 2);
k([
  W
], P.prototype, "saveModalOpen", 2);
k([
  W
], P.prototype, "renameTarget", 2);
k([
  _
], P.prototype, "publicGroups", 1);
k([
  _
], P.prototype, "personalGroups", 1);
k([
  _
], P.prototype, "lastAppliedTemplateId", 1);
k([
  _
], P.prototype, "hasAnyGroups", 1);
k([
  _
], P.prototype, "canCreate", 1);
k([
  y.bound
], P.prototype, "openSaveModal", 1);
k([
  y.bound
], P.prototype, "closeSaveModal", 1);
k([
  y.bound
], P.prototype, "openRenameModal", 1);
k([
  y.bound
], P.prototype, "closeRenameModal", 1);
k([
  y.bound
], P.prototype, "toggleGroupFavorite", 1);
k([
  U.bound
], P.prototype, "loadTemplatesForWell", 1);
k([
  U.bound
], P.prototype, "reloadForWellChange", 1);
k([
  U.bound
], P.prototype, "createGroupFromCurrentSelection", 1);
k([
  U.bound
], P.prototype, "createGroupWithTree", 1);
k([
  U.bound
], P.prototype, "renameGroup", 1);
k([
  U.bound
], P.prototype, "updateGroupWithCurrentTree", 1);
k([
  U.bound
], P.prototype, "applyGroup", 1);
k([
  U.bound
], P.prototype, "duplicateGroup", 1);
k([
  U.bound
], P.prototype, "deleteGroup", 1);
k([
  y.bound
], P.prototype, "restoreLastApplied", 1);
export {
  te as DEFAULT_REFERENCE_WELLS_VISIBILITY,
  pn as EMPTY_REFERENCE_WELLS_FILTERS,
  pl as REFERENCE_DATA_TEMPLATES_OBJECT_TYPE,
  P as ReferenceDataTemplatesStore,
  De as ReferenceWellsChildrenStore,
  ul as ReferenceWellsPanel,
  A as ReferenceWellsService,
  g as ReferenceWellsStore,
  Rt as isForcedDesign,
  Mt as isForcedFactBranch,
  ze as isForcedPlanBranch,
  $e as isForcedTrajectory,
  ve as isForcedWellbore,
  Nt as isSameForcedPrimarySelection,
  me as parseVersionedReferenceWellsSettings,
  dl as parseVersionedSelectedReferenceTree,
  fe as wrapVersionedSelectedReferenceTree
};
//# sourceMappingURL=reference-wells.es.js.map
